// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/RobotoMono-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/RobotoMono-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/RobotoMono-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/RobotoMono-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/Montserrat-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/Montserrat-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../images/delegation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../images/liquidity.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../images/danate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../images/check-solid.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../images/greyLogo/stakebin-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../images/greyLogo/Delight-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../images/greyLogo/Terrarium-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../images/greyLogo/terraport-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../images/greyLogo/nodeops-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/greyLogo/Burn it all grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/greyLogo/TCB-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../images/greyLogo/Vegas-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../images/greyLogo/Lunc-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../images/greyLogo/stake-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../images/greyLogo/hexxagon-grey.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/greyLogo/stakebin-Blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/greyLogo/Delight-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../images/greyLogo/Terrarium-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../images/greyLogo/terraport-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../images/greyLogo/nodeops-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../images/greyLogo/Burn it all.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../images/greyLogo/TCB-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../images/greyLogo/Vegas-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../images/greyLogo/Lunc.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("../images/greyLogo/stake-blue.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("../images/greyLogo/hexxagon-blue.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "Roboto Mono It";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}
@font-face {
  font-family: "Roboto Mono Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
/* VARIABLES */
/* MIXINS */
/* RESET CSS */
/* http://meyerweb.com/eric/tools/css/reset/
         v2.0 | 20110126
         License: none (public domain)
      */
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  color: inherit;
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}
a, a:hover, a:active, a:visited, a:focus {
  color: inherit;
}

i,
em,
.italic-text {
  font-style: italic;
}

.left {
  float: left;
}

.right {
  float: right;
}

.wrap-clear::after {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  zoom: 1;
  display: table;
  clear: both;
}
.clearfix:before, .clearfix:after {
  content: "";
  display: table;
}
.clearfix:after {
  clear: both;
}

:focus {
  outline: none;
}

input,
button,
textarea {
  border-radius: 0;
  appearance: none;
}

select {
  border-radius: 0;
}

textarea {
  resize: none;
}

/* COMMONS */
body {
  -webkit-font-smoothing: antialiased;
  letter-spacing: 0.6px;
}

ol,
ul {
  margin: 0px;
}

button,
input,
select,
textarea {
  appearance: none;
  outline: none;
  border-radius: 0;
  background-color: transparent;
}

input,
textarea {
  background: transparent;
  border: none;
}

input:focus,
select:focus,
textarea:focus,
button:focus,
a:focus {
  outline: none;
}

a {
  color: inherit;
  cursor: pointer;
}

.h1,
.h2,
.h3,
.h4,
h1,
h2,
h3,
h4 {
  line-height: 1.2;
}

p {
  line-height: 1.3;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.slick-next:before,
.slick-prev:before {
  content: "";
}

.scroll-lock {
  height: 100%;
  overflow-y: hidden;
}
small {
  font-size: 13px;
}

.input[type=checkbox] {
  appearance: checkbox;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

@media only screen and (min-width: 1025px) {
  .hidden-lg {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .hidden-xs {
    display: none !important;
  }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .hidden-md {
    display: none !important;
  }
}

.img-responsive {
  width: 100%;
  height: auto;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .container {
    width: 90%;
    max-width: 768px;
    margin: 0 auto;
  }
}
@media (max-width: 767px) {
  .container {
    width: 100%;
    padding: 0 20px;
    margin: 0 auto;
  }
}

.common-bg {
  background-position: center;
  background-repeat: no-repeat;
}

p {
  font-size: 15px;
}
@media (max-width: 767px) {
  p {
    font-size: 15px;
  }
}

h2 {
  font-weight: 600;
}

@media (max-width: 767px) {
  main {
    padding-top: 65px;
  }
}

header {
  background-color: #3b20e2;
}
header .logo {
  color: white;
  font-family: "Roboto Mono Regular";
  font-size: 26px;
  line-height: 1.2;
}
header a {
  color: white;
  font-family: "Roboto Mono Regular";
  display: inline-block;
  font-size: 19px;
  line-height: 1.2;
}
header .navbar {
  padding-top: 32px;
  padding-bottom: 32px;
  display: flex;
  justify-content: space-between;
}
header .navbar .nav {
  display: flex;
  column-gap: 60px;
  align-items: flex-start;
}
header .navbar .nav .nav-item {
  padding-bottom: 5px;
  color: white;
}
header .navbar .nav .nav-item.active {
  color: #f6fe01;
  border-bottom: #f6fe01 solid 1px;
}

#navbar {
  transition: 0.7s;
}

header {
  padding-top: 30px;
  padding-bottom: 15px;
}
@media (max-width: 767px) {
  header {
    position: fixed;
    transition: top 0.6s ease-in-out;
    left: 0;
    right: 0;
    z-index: 5000;
    z-index: 5000;
    padding-top: 15px;
    padding-bottom: 15px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header {
    padding-top: 15px;
    padding-bottom: 10px;
  }
}
header .header-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
header .header-main a {
  display: inline-block;
  font: 18px "Roboto Mono Regular";
  color: white;
  display: block;
  border-bottom: 1px solid transparent;
  display: inline-block;
}
header .header-main a #logo-brand {
  transition: 0.6s;
  font-size: 26px;
  line-height: 1.2;
}
header .header-main a img {
  display: inline-block;
  width: 80px;
}
@media (max-width: 767px) {
  header .header-main a img {
    width: 60px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main a img {
    width: 61px;
  }
}
@media (max-width: 767px) {
  header .header-main a {
    font-size: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main a {
    font-size: 24px;
  }
}
header .header-main .brand {
  font-size: 26px;
  line-height: 1.2;
}
@media (max-width: 767px) {
  header .header-main .brand {
    font-size: 22px;
  }
}
header .header-main .nav-menu {
  display: flex;
  gap: 2.5rem;
}
@media (max-width: 767px) {
  header .header-main .nav-menu {
    padding-top: 80px;
    z-index: -1;
    position: fixed;
    left: -100%;
    top: 70px;
    gap: 0;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    text-align: center;
    transition: 0.3s;
    overflow: hidden;
    background-color: #3b20e2;
  }
  header .header-main .nav-menu.active {
    left: 0;
  }
  header .header-main .nav-menu .nav-item {
    margin: 16px 0;
  }
}
@media (max-width: 767px) and (max-width: 767px) {
  header .header-main .nav-menu .nav-item {
    margin: 10px 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .nav-menu {
    position: fixed;
    left: -100%;
    top: 100px;
    gap: 0;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    text-align: center;
    transition: 0.3s;
    background-color: #3b20e2;
  }
  header .header-main .nav-menu.active {
    left: 0;
    padding-top: 3rem;
  }
  header .header-main .nav-menu .nav-item {
    margin: 10px 0;
  }
}
header .header-main .nav-item:hover {
  color: #f6fe01;
}
header .header-main .nav-item.active {
  color: #f6fe01;
  border-bottom: 1px solid #f6fe01;
  padding-bottom: 10px;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .nav-item {
    line-height: 2;
  }
}
header .header-main .nav-item .nav-link {
  display: inline-block;
  position: relative;
}
header .header-main .nav-item .nav-link:after {
  content: "";
  position: absolute;
  width: 100%;
  transform: scaleX(0);
  height: 2px;
  bottom: -18px;
  left: 0;
  background-color: white;
  transform-origin: bottom right;
  transition: transform 0.25s ease-out;
}
header .header-main .nav-item .nav-link:hover::after {
  transform: scaleX(1);
  transform-origin: bottom left;
}
header .header-main .hamburger {
  display: none;
  cursor: pointer;
}
header .header-main .hamburger .bar {
  display: block;
  width: 25px;
  height: 3px;
  margin: 5px auto;
  transition: all 0.3s ease-in-out;
  background-color: white;
}
header .header-main .hamburger .bar:nth-child(1) {
  opacity: 0;
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .hamburger .bar {
    width: 35px;
  }
}
@media (max-width: 767px) {
  header .header-main .hamburger {
    display: block;
  }
  header .header-main .hamburger.active .bar:nth-child(1) {
    opacity: 1;
    transform: translate(0px, 8px) rotate(45deg);
  }
  header .header-main .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }
  header .header-main .hamburger.active .bar:nth-child(3) {
    transform: translate(0px, -8px) rotate(-45deg);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  header .header-main .hamburger {
    display: block;
  }
  header .header-main .hamburger.active .bar:nth-child(1) {
    opacity: 1;
    transform: translate(0px, 8px) rotate(45deg);
  }
  header .header-main .hamburger.active .bar:nth-child(2) {
    opacity: 0;
  }
  header .header-main .hamburger.active .bar:nth-child(3) {
    transform: translate(0px, -8px) rotate(-45deg);
  }
}

.banner {
  background-color: #3b20e2;
}
.banner.dlp-banner {
  padding-bottom: 60px;
}
.banner .wrapper {
  display: flex;
  justify-content: center;
  padding-top: 60px;
  padding-bottom: 60px;
  gap: 4rem;
}
@media (max-width: 767px) {
  .banner .wrapper {
    gap: 2rem;
    padding-top: 40px;
    padding-bottom: 40px;
    flex-direction: column;
  }
}
.banner .wrapper.flex-donate {
  gap: 0;
}
@media (max-width: 767px) {
  .banner .wrapper.flex-donate {
    gap: 2rem;
  }
}
.banner .wrapper .flex-home {
  flex: 3 1;
}
.banner .wrapper .flex-home h1 {
  font-family: "Roboto Mono Regular";
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: capitalize;
  color: white;
  display: inline;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home h1 {
    font-size: 22px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .banner .wrapper .flex-home h1 {
    font-size: 33px;
  }
}
.banner .wrapper .flex-home h2 {
  font-family: "Roboto Mono Regular";
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: capitalize;
  color: white;
  background: #3b20e2;
  display: inline;
  line-height: 1.5;
}
.banner .wrapper .flex-home h3 {
  font-family: "Roboto Mono Regular";
  font-size: 60px;
  line-height: 1.1;
  font-weight: 700;
  text-transform: capitalize;
  color: white;
  background: #3b20e2;
  display: inline;
}
.banner .wrapper .flex-home p {
  margin-top: 2rem;
  font-family: "Roboto Mono Regular";
  color: white;
  font-size: 24px;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home p {
    max-width: 100%;
    font-size: 16px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .banner .wrapper .flex-home p {
    font-size: 16px;
  }
}
.banner .wrapper .flex-home a {
  margin-top: 2rem;
  display: inline-block;
  padding: 20px 40px;
  font-family: "Roboto Mono Regular";
  font-size: 24px;
  border: 2px white solid;
  border-radius: 10px;
  color: white;
  align-self: flex-start;
}
.banner .wrapper .flex-home a:hover {
  color: #3b20e2;
  background-color: white;
  border: 2px white solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home a {
    padding: 10px 20px;
    font-size: 18px;
    border: 1px white solid;
  }
}
@media (max-width: 767px) {
  .banner .wrapper .flex-home h2 {
    font-size: 36px;
  }
}
.banner .wrapper .flex-img {
  flex: 3 1;
}
.banner .wrapper .flex-img .donate-hero-img {
  width: 70%;
  margin-left: auto;
}
@media (max-width: 767px) {
  .banner .wrapper .flex-img .donate-hero-img {
    width: 70%;
    margin: auto;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .banner .wrapper .flex-img .donate-hero-img {
    width: 100%;
    margin: auto;
  }
}
@media only screen and (min-width: 1025px) {
  .banner {
    border-top: 15px solid #3b20e2;
    border-bottom: 15px solid #3b20e2;
  }
}
@media (max-width: 767px) {
  .banner {
    flex-direction: column;
  }
}

.about {
  background-color: #f5f5f5;
}
.about .wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
@media (max-width: 767px) {
  .about .wrapper {
    padding-top: 40px;
  }
}
.about .wrapper .donate-copy-header {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
  font-weight: 600;
}
@media (max-width: 767px) {
  .about .wrapper .donate-copy-header {
    font-size: 25px;
  }
}
.about .wrapper h2 {
  font-family: "Roboto Mono Regular";
  font-size: 41px;
  margin-bottom: 1rem;
  color: white;
  line-height: 1.2;
}
@media (max-width: 767px) {
  .about .wrapper h2 {
    font-size: 25px;
  }
}
.about .wrapper h3 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .about .wrapper h3 {
    font-size: 25px;
  }
}
.about .wrapper p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 25px;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .about .wrapper p {
    line-height: 1.4;
  }
}
.about .wrapper .column-wrap .column {
  padding: 50px;
  background-color: #3b20e2;
  color: white;
  border-radius: 10px;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column {
    padding: 35px 20px;
  }
}
.about .wrapper .column-wrap .column .copy-wrap-dl {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 250px;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column .copy-wrap-dl {
    height: unset;
  }
}
.about .wrapper .column-wrap .column .copy-delegation {
  line-height: 1.4;
  font-weight: unset;
  margin-bottom: 40px;
  font-size: 16px;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column .copy-delegation {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 16px;
  }
}
.about .wrapper .column-wrap .column a {
  display: inline-block;
  padding: 20px 40px;
  font-family: "Roboto Mono Regular";
  font-size: 24px;
  border: 2px white solid;
  border-radius: 10px;
}
.about .wrapper .column-wrap .column a:hover {
  color: #3b20e2;
  background-color: white;
  border: 2px white solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column a {
    padding: 10px 20px;
    font-size: 18px;
    border: 1px white solid;
  }
}
.about .wrapper .column-wrap .column.col-del {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: 96% 4%;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-del {
    background-size: 28%;
    background-position: 95% 4%;
  }
}
.about .wrapper .column-wrap .column.col-liq {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: 95% 10%;
  flex-direction: column;
  align-items: flex-start;
}
.about .wrapper .column-wrap .column.col-liq .copy-wrap-dl {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 250px;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-liq .copy-wrap-dl {
    height: unset;
  }
}
.about .wrapper .column-wrap .column.col-liq p {
  font-size: 16px;
  font-weight: 400;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-liq p {
    font-size: 16px;
  }
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap .column.col-liq {
    background-size: 28%;
  }
}
.about .wrapper .column-wrap.column-wrap-2 {
  margin-top: 30px;
}
.about .wrapper .column-wrap.column-wrap-2 .col-del {
  flex: 1 1;
}
.about .wrapper .column-wrap.column-wrap-2 .col-del .copy-wrap-dl {
  height: unset;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap-page {
    padding-bottom: 0px;
  }
}
.about .wrapper .column-wrap-page p {
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  line-height: 1.5;
}
.about .wrapper .column-wrap-page p .link-a {
  color: #3b20e2;
  font-weight: 700;
}
.about .wrapper .column-wrap-page p .link-a:hover {
  color: #08d0ae;
  transition: all 0.2s ease-in-out;
}
.about .wrapper .column-wrap-page .page-btn {
  margin-top: 55px;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap-page .page-btn {
    margin-top: 30px;
  }
}
.about .wrapper .column-wrap-page .page-btn a {
  display: table;
  font-family: "Roboto Mono Regular";
  padding: 20px 40px;
  font-size: 24px;
  border: 2px #3b20e2 solid;
  border-radius: 10px;
  background-color: transparent;
  color: #3b20e2;
  margin-bottom: 18px;
}
.about .wrapper .column-wrap-page .page-btn a:hover {
  color: white;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .about .wrapper .column-wrap-page .page-btn a {
    padding: 10px 20px;
    font-size: 18px;
    border: 1px #3b20e2 solid;
  }
}
.about .wrapper .donate {
  margin-top: 20px;
  background-color: white;
  border-radius: 8px;
  padding: 50px;
  flex-direction: column;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: 96% 10%;
}
@media (max-width: 767px) {
  .about .wrapper .donate {
    padding: 35px 20px;
    background-size: 45%;
    background-position: 95% 10%;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .about .wrapper .donate {
    background-size: 50%;
  }
}
.about .wrapper .donate h2 {
  color: #3b20e2;
  font-family: "Roboto Mono Regular";
  font-size: 41px;
}
@media (max-width: 767px) {
  .about .wrapper .donate h2 {
    font-size: 32px;
    margin-bottom: 15px;
  }
}
.about .wrapper .donate .copy-donate {
  color: #3b20e2;
  line-height: 1.4;
  font-weight: unset;
  max-width: 40%;
}
@media (max-width: 767px) {
  .about .wrapper .donate .copy-donate {
    max-width: 100%;
  }
}
.about .wrapper .donate a {
  display: table;
  padding: 20px 40px;
  font-family: "Roboto Mono Regular";
  font-size: 24px;
  border: 2px #3b20e2 solid;
  border-radius: 10px;
  background-color: white;
  color: #3b20e2;
}
.about .wrapper .donate a:hover {
  color: white;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .about .wrapper .donate a {
    padding: 12px 22px;
    font-size: 18px;
  }
}

.description .wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
.description .wrapper .title h2 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .description .wrapper .title h2 {
    font-size: 25px;
  }
}
.description .wrapper .title p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 1rem;
  line-height: 1.5;
}
.description .wrapper .copy h2 {
  padding-top: 5px;
  font-family: "Roboto Mono Regular";
  margin-bottom: 0.5rem;
  font-weight: 700;
  color: #3b20e2;
  line-height: 1.5;
}
.description .wrapper .copy p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 1rem;
  line-height: 1.5;
}

footer {
  background-color: #000;
  color: white;
}

.grey {
  background-color: #f5f5f5;
}

hr {
  border: 1px solid #c3bfbf;
}

.about1 .wrapper {
  padding-top: 30px;
  padding-bottom: 30px;
}
.about1 .wrapper h2 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  color: #3b20e2;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .about1 .wrapper h2 {
    font-size: 25px;
  }
}
.about1 .wrapper p {
  font-family: "Roboto Mono Regular";
  margin-bottom: 1rem;
  line-height: 1.5;
}

.column-wrap {
  display: flex;
}
@media only screen and (min-width: 1025px) {
  .column-wrap {
    gap: 20px;
  }
  .column-wrap .column {
    flex-basis: 50%;
  }
}
@media (max-width: 767px) {
  .column-wrap {
    flex-direction: column;
    row-gap: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .column-wrap {
    flex-direction: column;
    row-gap: 20px;
  }
}

footer {
  padding-top: 50px;
  padding-bottom: 50px;
}
@media (max-width: 767px) {
  footer {
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
footer .wrapper {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 767px) {
  footer .wrapper {
    row-gap: 20px;
  }
}
footer .wrapper .col .logo {
  line-height: 1.2;
  font-family: "Roboto Mono Regular";
  font-weight: 700;
  font-size: 24px;
}
footer .wrapper .col .head {
  font-family: "Roboto Mono Regular";
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 10px;
  color: #807f80;
}
@media (max-width: 767px) {
  footer .wrapper .col .head {
    margin-bottom: 5px;
    font-size: 20px;
  }
}
footer .wrapper .col a {
  font-family: "Roboto Mono Regular";
  line-height: 1.9;
}
@media (max-width: 767px) {
  footer .wrapper .col a {
    line-height: 1.4;
  }
}
footer .wrapper .col .brand img {
  width: 90px;
}
@media (max-width: 767px) {
  footer .wrapper .col .brand img {
    width: 75px;
  }
}

/* MODAL */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.modal-close-button {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 18px;
  width: 22px;
  height: 22px;
  background-color: transparent;
  border: none;
  cursor: pointer;
  background: #efefef;
  border-radius: 50%;
  color: gray;
}
.modal-close-button span {
  font-size: 26px;
}
.modal-close-button:hover {
  color: black;
}

.qr-code {
  max-width: 320px;
  margin: 0 auto;
}

.container a {
  word-wrap: break-word;
}

.qr-wallet {
  text-align: center;
}
.qr-wallet .wallet-tc {
  font-size: 10px;
  margin-bottom: 0px !important;
}
.qr-wallet .wallet-tc .hover-tc:hover {
  text-decoration: underline;
}
.qr-wallet .wallet-address {
  margin-bottom: 10px !important;
}
.qr-wallet h4 {
  font-size: 22px;
  margin-bottom: 20px;
  font-family: "Roboto Mono Regular";
}
.qr-wallet .qr-wrap {
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .qr-wallet .wallet-address {
    font-size: 11px;
  }
}

.form-container {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;
  max-width: 70%;
}
@media (max-width: 767px) {
  .form-container {
    max-width: 100%;
  }
}

.form-input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-bottom: 10px;
  font-family: "Roboto Mono Regular";
  width: 100%;
  color: rgb(5, 5, 5);
}

.div-form {
  width: 45%;
  margin-bottom: 10px;
}
@media (max-width: 767px) {
  .div-form {
    width: 100%;
  }
}

.class-checkbox {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.wallet-ad {
  width: 70%;
}

.div-tick {
  display: flex;
}

.checkbox-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  width: 80%;
  justify-content: center;
}
@media (max-width: 767px) {
  .checkbox-group {
    width: 100%;
  }
}

.checkbox-group label {
  margin-left: 5px;
  font-family: "Roboto Mono Regular";
  margin-bottom: 10px;
}

.submit-btn {
  width: 60%;
  display: table;
  padding: 10px 30px;
  font-family: "Roboto Mono Regular";
  font-size: 16px;
  border: 2px #3b20e2 solid;
  border-radius: 10px;
  background-color: white;
  text-align: center;
  color: #3b20e2 !important;
}
.submit-btn:hover {
  color: white !important;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .submit-btn {
    padding: 12px 22px;
    font-size: 18px;
  }
}

input[type=checkbox] {
  display: none;
}

/* Style the custom tick */
.custom-tick {
  display: inline-block;
  width: 20fpx;
  height: 16px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-right: 8px;
}

.custom-tick svg {
  display: block;
  width: 100%;
  height: 100%;
}

.error {
  color: red;
  font-family: "Roboto Mono Regular";
  font-size: 12px;
}

/* styles.css (or any other CSS file) */
/* styles.css (or any other CSS file) */
.form-checkbox {
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
}

.form-checkbox input {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}

.form-checkbox .checkmark {
  position: absolute;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-checkbox .checkmark::after {
  content: "";
  position: absolute;
  display: none;
}

.form-checkbox input:checked + .checkmark::after {
  display: block;
  content: "✓"; /* Checkmark Unicode character */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right;
  background-size: contain;
  text-align: center;
  line-height: 20px;
  font-size: 24px;
  color: transparent;
}

.form-checkbox input:required:not(:checked) + .checkmark {
  border-color: rgb(76, 0, 255);
}

.custom-checkbox {
  position: relative;
  padding-left: 25px; /* Space for the custom tick */
  cursor: pointer;
}

/* Styling the custom tick */
.custom-checkbox .checkbox-tick {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #fff;
  border: 2px solid #333;
  border-radius: 3px;
}

/* Styling the custom tick when the checkbox is checked */
.custom-checkbox .checkbox-tick::after {
  content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid #007bff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

/* Show the custom tick when the checkbox is checked */
.custom-checkbox input:checked + .checkbox-tick::after {
  display: block;
}

/* Hide the default checkbox */
.custom-checkbox input {
  display: none;
}

.terms-c {
  max-width: 60%;
  margin: auto;
}
@media (max-width: 767px) {
  .terms-c {
    max-width: 100%;
  }
}
.terms-c h2 {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  margin-bottom: 1rem;
  margin-top: 1rem;
  color: #3b20e2;
  line-height: 1.5;
  text-align: center;
}
@media (max-width: 767px) {
  .terms-c h2 {
    font-size: 20px;
  }
}
.terms-c ul {
  list-style: auto;
}
@media (max-width: 767px) {
  .terms-c ul {
    padding-left: 30px;
  }
}
.terms-c ul li {
  margin-bottom: 20px;
  font-family: "Roboto Mono Regular";
  line-height: 1.6;
}
@media (max-width: 767px) {
  .terms-c ul li {
    font-size: 14px;
  }
}

.options button {
  margin: 15px;
  padding: 18px 16px;
  border: none;
  cursor: pointer;
}
.options button .wrapper-icon {
  display: flex;
  align-items: center;
  width: 25px;
  height: 25px;
  margin: auto;
}
.options button .credit-card {
  margin: auto;
}
.options button .crypto-card {
  width: 16px;
  margin: auto;
}
@media (max-width: 767px) {
  .options button .crypto-card {
    width: 13px;
  }
}

.options button.selected {
  background-color: #3b20e2;
  color: white !important;
}

.pay-now-btn {
  padding: 10px 20px;
  background-color: #2ecc71;
  border: none;
  color: white;
  cursor: pointer;
}

.pay-now-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.amount-input {
  margin: 10px 0;
  color: black;
}
.amount-input label {
  display: block;
  margin-bottom: 5px;
}
@media (max-width: 767px) {
  .amount-input label {
    font-size: 14px;
    line-height: 1.4;
  }
}

.amount-input input {
  width: 100%;
  padding: 8px;
}

.modal-content {
  background-color: white;
  padding: 30px 0;
  border-radius: 8px;
  text-align: center;
  font-family: "Roboto Mono Regular";
  max-width: 900px;
}
.modal-content .copy-head {
  margin-bottom: 40px;
  color: #3b20e2;
  text-align: center;
  font-family: "Roboto Mono Regular";
  font-weight: 700;
  font-size: 19px;
}
@media (max-width: 767px) {
  .modal-content .copy-head {
    margin-bottom: 30px;
    padding: 0 30px;
    font-size: 15px;
  }
}
@media (max-width: 767px) {
  .modal-content {
    width: 90%;
    padding-top: 25px;
    margin: auto;
  }
}
.modal-content h2 {
  color: #3b20e2;
  font-size: 20px;
  text-align: start;
  margin-bottom: 20px;
}
.modal-content p {
  color: black;
  text-align: left;
}
.amount-input {
  display: flex;
  align-items: center;
  margin: 10px 0;
  text-align: left;
  font-family: "Roboto Mono Regular";
  border-bottom: 1px solid #d7d7d7;
}
@media (max-width: 767px) {
  .amount-input {
    margin-bottom: 10px;
  }
}

.amount-input label {
  font-family: "Roboto Mono Regular";
  font-weight: bold;
}

.amount-input input {
  flex: 1 1;
  margin-left: 5px;
  padding: 8px;
  border: 1px solid #3b20e2;
  border-radius: 4px;
  max-width: 200px;
}

input[type=text]:focus {
  border: 2px solid #3b20e2;
}

::placeholder {
  font-family: "Roboto Mono Regular";
}

.total-amount {
  font-weight: bold;
  color: black;
  font-family: "Roboto Mono Regular";
  border-top: 1px solid #ccc;
  padding-top: 25px;
  margin-bottom: 25px;
}
.options {
  border-radius: 5px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 10px;
  font-family: "Roboto Mono Regular";
}
@media (max-width: 767px) {
  .options {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
.options p {
  text-align: center;
  margin-bottom: 20px;
  font-size: 16px;
  color: black;
}
.options .payment-div {
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
}
.options .payment-div .or-name {
  font-size: 1.2rem;
  font-family: "Roboto Mono Regular";
  text-transform: uppercase;
}
.options .payment-div .white-color {
  color: #3b20e2;
}
.options .payment-div p {
  font-size: 15px;
}

.options button {
  margin: 10px;
  padding: 20px 21px;
  border: none;
  cursor: pointer;
  font-family: "Roboto Mono Regular";
  color: #3b20e2;
  border-radius: 50%;
  border: 1px solid #3b20e2;
}
@media (max-width: 767px) {
  .options button {
    padding: 13px 14px;
  }
}

.options button.selected {
  color: white;
  border-radius: 50%;
}

.pay-now-btn {
  display: table;
  padding: 12px 42px;
  font-family: "Roboto Mono Regular";
  font-size: 26px;
  border: 2px #3b20e2 solid;
  border-radius: 5px;
  background-color: white;
  color: #3b20e2;
  margin: auto;
  margin-bottom: 15px;
}
.pay-now-btn:hover {
  color: white;
  background-color: #3b20e2;
  border: 2px #3b20e2 solid;
  transition: 0.3s all ease-in-out;
}
@media (max-width: 767px) {
  .pay-now-btn {
    padding: 10px 22px;
    font-size: 21px;
  }
}

.pay-now-btn:disabled {
  background-color: white;
  color: #3b20e2;
  cursor: not-allowed;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  row-gap: 5px;
  position: relative;
}
.input-wrapper .error-message-0 {
  color: red !important;
  font-size: 9px;
  position: absolute;
  left: 5px;
  bottom: -54%;
  width: 123%;
}
@media (max-width: 767px) {
  .input-wrapper .error-message-0 {
    position: absolute;
    left: 7px;
    bottom: -42%;
  }
}

.error-message-1 {
  color: red !important;
  position: absolute !important;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 9px !important;
}
@media (max-width: 767px) {
  .error-message-1 {
    width: 100%;
  }
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  outline: none;
  color: #3b20e2 !important;
}
@media (max-width: 767px) {
  .close-btn {
    top: 5px;
    right: 5px;
  }
}

.main-div {
  position: relative;
}
.main-div .banner {
  padding-bottom: 9rem;
}
@media (max-width: 767px) {
  .main-div .banner {
    padding-bottom: 9rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .main-div .banner {
    padding-bottom: 11rem;
  }
}
.main-div .about {
  padding-top: 15rem;
}
@media (max-width: 767px) {
  .main-div .about {
    padding-top: 15rem;
  }
}
.main-div .donate-page-form {
  max-width: 900px;
  position: absolute;
  top: 0;
  position: absolute;
  top: 58%; /* position the top  edge of the element at the middle of the parent */
  left: 50%; /* position the left edge of the element at the middle of the parent */
  transform: translate(-50%, -57%);
  width: 80%;
}
@media (max-width: 767px) {
  .main-div .donate-page-form {
    top: 50%; /* position the top  edge of the element at the middle of the parent */
    left: 50%; /* position the left edge of the element at the middle of the parent */
    width: 100%;
    transform: translate(-50%, -50%);
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .main-div .donate-page-form {
    top: 60%;
  }
}

.server-program .container {
  width: 90%;
}
.server-program .faq {
  background-color: #f5f5f5;
  padding-top: 50px;
  padding-bottom: 50px;
}
.server-program .faq .about-wrapper {
  border-radius: 20px;
  padding: 3rem;
  background-color: #3b20e2;
  display: flex;
  align-items: flex-start;
}
@media (max-width: 767px) {
  .server-program .faq .about-wrapper {
    padding: 2rem;
    flex-direction: column;
  }
}
.server-program .faq .about-wrapper .about-head {
  flex: 1 1;
  font-size: 30px;
  color: white;
  font-family: "Roboto Mono Regular";
}
@media (max-width: 767px) {
  .server-program .faq .about-wrapper .about-head {
    font-size: 25px;
  }
}
.server-program .faq .about-wrapper .about-copy {
  flex: 2 1;
}
.server-program .faq .about-wrapper .about-copy .copy {
  color: white;
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  margin-top: 10px;
  margin-bottom: 30px;
  line-height: 1.5;
}
.server-program .faq .about-wrapper .about-copy .copy:last-child {
  margin-bottom: unset;
}
.server-program .faq .faq-wrapper {
  padding: 3rem;
  margin-top: 50px;
  border-radius: 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background-color: white;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper {
    flex-direction: column;
    padding: 2rem;
    margin-top: 30px;
  }
}
.server-program .faq .faq-wrapper .faq-head {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  color: #3b20e2;
  flex: 1 1;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-head {
    font-size: 25px;
  }
}
.server-program .faq .faq-wrapper .faq-item {
  flex: 2 1;
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans {
  padding-right: 30px;
  font-family: "Roboto Mono Regular";
  margin-bottom: 30px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans {
    padding-right: 0px;
  }
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans:last-child {
    margin-bottom: 10px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .qt {
  color: #3b20e2;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 8px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .qt {
    font-size: 15px;
    margin-top: 20px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans {
  font-size: 16px;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans {
    font-size: 14px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans .link-a {
  color: #3b20e2;
  font-weight: 700;
}
.server-program .faq .faq-wrapper .faq-item .faq-copy-wrapper .qt-ans .ans .link-a:hover {
  color: #08d0ae;
  transition: all 0.2s ease-in-out;
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper {
  margin-bottom: 30px;
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item {
  margin-bottom: 10px;
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-title {
  background-color: #3b20e2;
  padding: 10px;
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: white;
  font-family: "Roboto Mono Regular";
  border-radius: 10px;
  font-size: 20px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-title {
    font-size: 15px;
  }
}
.server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-content {
  padding: 10px;
  background-color: #fafafa;
  font-family: "Roboto Mono Regular";
  font-size: 16px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
@media (max-width: 767px) {
  .server-program .faq .faq-wrapper .faq-item .accordion-wrapper .accordion-item .accordion-content {
    font-size: 14px;
  }
}
.server-program .faq .faq-wrapper .faq-item .faq-acc-ans .flex-class {
  display: flex;
  margin-bottom: 5px;
}
.server-program .faq .faq-wrapper .faq-item .faq-acc-ans .flex-class .flex-item {
  flex: 1 1;
}
.server-program .faq .faq-wrapper .faq-item .faq-acc-ans .flex-class .flex-item1 {
  flex: 2 1;
}

.floating-card {
  position: relative;
  padding-bottom: 280px;
  background-color: #f5f5f5;
}
.floating-card .fc-wrapper {
  position: absolute;
  top: -70px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 20px;
}
.floating-card .fc-wrapper .loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: transparent;
  position: fixed;
  top: -140px;
  left: 0;
  right: 0;
  bottom: 0;
}
.floating-card .fc-wrapper .loading-spinner::after {
  content: "";
  width: 34px;
  height: 34px;
  border: 2px solid #3b20e2;
  border-radius: 50%;
  border-top-color: transparent;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.floating-card .fc-wrapper .fc-card {
  flex: 1 0 28%;
  color: #3b20e2;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 40px 20px;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  border-radius: 15px;
}
.floating-card .fc-wrapper .fc-card .numbers {
  font-family: "Roboto Mono Regular";
  font-size: 32px;
  font-weight: 700;
}
.floating-card .fc-wrapper .fc-card .copy {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  text-align: center;
  font-weight: 700;
}
@media (max-width: 767px) {
  .floating-card {
    padding-bottom: 638px;
  }
  .floating-card .fc-wrapper {
    flex-direction: column;
  }
  .floating-card .fc-wrapper .fc-card {
    padding: 20px;
  }
  .floating-card .fc-wrapper .fc-card .numbers {
    font-size: 20px;
  }
  .floating-card .fc-wrapper .fc-card .copy {
    font-size: 20px;
  }
}

.about-program {
  background-color: #f5f5f5;
  padding: 50px 0;
  padding-bottom: 80px;
}
@media (max-width: 767px) {
  .about-program {
    padding-bottom: 60px;
  }
}
@media (max-width: 767px) {
  .about-program {
    padding-left: 20px;
    padding-right: 20px;
  }
}
.about-program .ap-wrapper {
  position: relative;
  background-color: #3b20e2;
  padding: 60px 40px;
  border-radius: 15px;
}
@media (max-width: 767px) {
  .about-program .ap-wrapper {
    padding: 40px 20px;
  }
}
.about-program .ap-wrapper .about-one {
  position: absolute;
  top: 0;
  width: 100px;
  right: 0px;
  top: -60px;
  right: 100px;
}
@media (max-width: 767px) {
  .about-program .ap-wrapper .about-one {
    width: 60px;
    top: -30px;
    right: 20px;
  }
}
.about-program .ap-wrapper .about-two {
  position: absolute;
  bottom: 0;
  width: 60px;
  bottom: -30px;
}
@media (max-width: 767px) {
  .about-program .ap-wrapper .about-two {
    width: 40px;
    bottom: -20px;
  }
}
.about-program .ap-wrapper .abt-heading {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  color: white;
  font-weight: 700;
}
.about-program .ap-wrapper .abt-copy {
  color: white;
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  line-height: 1.5;
  margin-top: 16px;
}

.delegation-criteria {
  background-color: white;
  padding: 60px 0;
}
.delegation-criteria .dc-heading {
  font-family: "Roboto Mono Regular";
  font-size: 30px;
  color: #3b20e2;
  text-transform: capitalize;
  margin-bottom: 1rem;
  font-weight: 700;
}
@media (max-width: 767px) {
  .delegation-criteria {
    padding: 40px 0;
  }
}
.delegation-criteria .dc-wrapper {
  display: flex;
  gap: 40px;
}
.delegation-criteria .dc-wrapper .wrapper-item {
  position: relative;
  padding-bottom: 400px;
  flex: 1 1;
}
@media (max-width: 767px) {
  .delegation-criteria .dc-wrapper .wrapper-item {
    padding-bottom: 370px;
  }
}
.delegation-criteria .dc-wrapper .wrapper-item .dc-copy {
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 40px;
}
@media (max-width: 767px) {
  .delegation-criteria .dc-wrapper .wrapper-item .dc-copy {
    margin-bottom: 30px;
  }
}
.delegation-criteria .dc-wrapper .wrapper-item .img-wrap {
  height: 400px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  justify-content: center;
}
@media (max-width: 767px) {
  .delegation-criteria .dc-wrapper .wrapper-item .img-wrap {
    height: 350px;
  }
}
.delegation-criteria .dc-wrapper .wrapper-item .img-wrap .img-1 {
  align-self: auto;
  width: 90px;
}
.delegation-criteria .dc-wrapper .wrapper-item .img-wrap .img-2 {
  align-self: flex-end;
  width: 90px;
}
.delegation-criteria .dc-wrapper .wrapper-item .img-wrap .img-3 {
  align-self: flex-start;
  width: 90px;
}
.delegation-criteria .dc-wrapper .wrapper-accordion {
  flex: 1 1;
  margin-bottom: 10px;
}
.delegation-criteria .dc-wrapper .wrapper-accordion .accordion-item {
  margin-bottom: 20px;
}
.delegation-criteria .dc-wrapper .wrapper-accordion .accordion-title {
  background-color: #3b20e2;
  padding: 10px;
  cursor: pointer;
  border: none;
  width: 100%;
  text-align: left;
  display: flex;
  justify-content: space-between;
  font-size: 18px;
  color: white;
  font-family: "Roboto Mono Regular";
  border-radius: 10px;
  font-size: 20px;
  font-weight: 700;
}
@media (max-width: 767px) {
  .delegation-criteria .dc-wrapper .wrapper-accordion .accordion-title {
    font-size: 15px;
  }
}
.delegation-criteria .dc-wrapper .wrapper-accordion .accordion-content {
  padding: 10px;
  background-color: #fafafa;
  font-family: "Roboto Mono Regular";
  font-size: 15px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  transition: 0.3s ease-out;
  line-height: 1.5;
}
@media (max-width: 767px) {
  .delegation-criteria .dc-wrapper .wrapper-accordion .accordion-content {
    font-size: 14px;
  }
}
@media (max-width: 767px) {
  .delegation-criteria .dc-wrapper {
    flex-direction: column;
  }
}

.delegated-validators {
  background-color: #f5f5f5;
  padding: 60px 0;
}
@media (max-width: 767px) {
  .delegated-validators {
    padding: 40px 0;
  }
}
.delegated-validators .dv-wrapper .dv-header {
  display: flex;
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-header {
    flex-direction: column;
  }
}
.delegated-validators .dv-wrapper .dv-header .dv-heading {
  flex: 1 1;
  font-family: "Roboto Mono Regular";
  font-size: 34px;
  color: #3b20e2;
  font-weight: 700;
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-header .dv-heading {
    margin-bottom: 20px;
  }
}
.delegated-validators .dv-wrapper .dv-header p {
  flex: 1 1;
  font-family: "Roboto Mono Regular";
}
.delegated-validators .dv-wrapper .dv-card-section {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin-top: 80px;
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-card-section {
    padding: 0 60px;
    gap: 10px;
    grid-template-columns: repeat(1, 1fr);
    gap: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .delegated-validators .dv-wrapper .dv-card-section {
    padding: 0 40px;
    column-gap: 30px;
    grid-template-columns: repeat(2, 1fr);
  }
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card {
  padding: 40px 30px;
  border-radius: 10px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  flex: 1 0 28%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding-top: 60px;
  cursor: pointer;
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-card-section .dv-card {
    padding: 20px;
    padding-top: 40px;
    gap: 20px;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .delegated-validators .dv-wrapper .dv-card-section .dv-card {
    padding: 20px;
    margin-top: 30px;
  }
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .num-plate {
  border: 1px #cfcfcf solid;
  border-radius: 50%;
  padding: 12px;
  font-family: "Roboto Mono Regular";
  align-self: flex-start;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .img-copy-wrapper {
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  gap: 100px;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .card-copy {
  font-family: "Roboto Mono Regular";
  color: #8f8f8f;
  font-size: 24px;
  font-weight: 700;
  text-align: start;
  align-self: flex-start;
  margin-top: 60px;
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-card-section .dv-card .card-copy {
    margin-top: 30px;
    font-size: 20px;
  }
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .card-img {
  margin-top: 60px;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: 1;
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-card-section .dv-card .card-img {
    width: 130px;
    margin-top: 30px;
  }
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .stakebin {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .delight {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .terrarium {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .terraport {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .nodeops {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .burnit-all {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .tcb {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .vegas {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .lunc {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .stake-system {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card .hexxagon {
  width: 110px;
  height: 110px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  background-position: center;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover {
  transition: 0.3s all;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .num-plate {
  color: white;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .card-copy {
  transition: 0.3s all;
  transition-delay: 0.001s;
  color: #3b20e2;
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .stakebin {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .delight {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .terrarium {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .terraport {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .nodeops {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .burnit-all {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .tcb {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .vegas {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .lunc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .stake-system {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.delegated-validators .dv-wrapper .dv-card-section .dv-card:hover .hexxagon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}
@media (max-width: 767px) {
  .delegated-validators .dv-wrapper .dv-card-section {
    flex-direction: column;
    align-items: unset;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/main.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,6BAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AACF;AAEA;EACE,kCAAA;EACA,oHAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAIA;EACE,yBAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAMA,cAAA;AAOA,WAAA;AAsDA,cAAA;AAEA;;;OAAA;AAKA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAiFE,cAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;AAjEF;;AAmEA,gDAAA;AACA;;;;;;;;;;;EAWE,cAAA;AAhEF;;AAkEA;EACE,cAAA;AA/DF;;AAiEA;;EAEE,gBAAA;AA9DF;;AAgEA;;EAEE,YAAA;AA7DF;;AA+DA;;;;EAIE,WAAA;EACA,aAAA;AA5DF;;AA8DA;EACE,yBAAA;EACA,iBAAA;AA3DF;;AA8DA;EACE,sBAAA;AA3DF;;AA8DA;EASE,qBAAA;AAnEF;AA2DE;EAKE,cAAA;AA7DJ;;AAmEA;;;EAGE,kBAAA;AAhEF;;AAmEA;EACE,WAAA;AAhEF;;AAkEA;EACE,YAAA;AA/DF;;AAkEA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AA/DF;;AAiEA;EACE,OAAA;EACA,cAAA;EACA,WAAA;AA9DF;AAgEE;EAEE,WAAA;EACA,cAAA;AA/DJ;AAkEE;EACE,WAAA;AAhEJ;;AAoEA;EACE,aAAA;AAjEF;;AAoEA;;;EAGE,gBAAA;EACA,gBAAA;AAjEF;;AAoEA;EACE,gBAAA;AAjEF;;AAoEA;EACE,YAAA;AAjEF;;AAoEA,YAAA;AAEA;EACE,mCAAA;EACA,qBAAA;AAlEF;;AAqEA;;EAEE,WAAA;AAlEF;;AAqEA;;;;EAKE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,6BAAA;AAlEF;;AAqEA;;EAEE,uBAAA;EACA,YAAA;AAlEF;;AAqEA;;;;;EAKE,aAAA;AAlEF;;AAqEA;EACE,cAAA;EACA,eAAA;AAlEF;;AAqEA;;;;;;;;EAQE,gBAAA;AAlEF;;AAqEA;EACE,gBAAA;AAlEF;;AAoEA;EACE,cAAA;EACA,eAAA;EACA,YAAA;AAjEF;;AAoEA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAjEF;;AAoEA,YAAA;AACA;EACE,0BAAA;AAjEF;;AAoEA;;EAEE,WAAA;AAjEF;;AAoEA;EACE,YAAA;EACA,kBAAA;AAjEF;AAwEA;EACE,eAAA;AAtEF;;AAyEA;EAEE,oBAAA;EACA,sBAAA;AAtEF;;AAwEA;EACE,uBAAA;AArEF;;AA7QI;EAqVJ;IAEI,wBAAA;EArEF;AACF;;AA3RI;EAkWJ;IAEI,wBAAA;EApEF;AACF;;AA7RI;EAmWJ;IAEI,wBAAA;EAnEF;AACF;;AAsEA;EACE,WAAA;EACA,YAAA;AAnEF;;AAsEA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAnEF;AA9SI;EA8WJ;IAMI,UAAA;IACA,gBAAA;IACA,cAAA;EAlEF;AACF;AAzTI;EAkXJ;IAWI,WAAA;IACA,eAAA;IACA,cAAA;EAhEF;AACF;;AAmEA;EACE,2BAAA;EACA,4BAAA;AAhEF;;AAmEA;EACE,eAAA;AAhEF;AAzUI;EAwYJ;IAGI,eAAA;EA9DF;AACF;;AAiEA;EACE,gBAAA;AA9DF;;AAlVI;EAkZJ;IAEI,iBAAA;EA7DF;AACF;;AA+DA;EACE,yBAAA;AA5DF;AA6DE;EACE,YAAA;EACA,kCAvaM;EAwaN,eAAA;EACA,gBAAA;AA3DJ;AA6DE;EACE,YAAA;EACA,kCA7aM;EA8aN,qBAAA;EACA,eAAA;EACA,gBAAA;AA3DJ;AA6DE;EACE,iBAAA;EACA,oBAAA;EArZF,aAAA;EAuZE,8BAAA;AAvDJ;AAwDI;EACE,aAAA;EACA,gBAAA;EACA,uBAAA;AAtDN;AAuDM;EACE,mBAAA;EACA,YAAA;AArDR;AAsDQ;EACE,cAAA;EACA,gCAAA;AApDV;;AA0DA;EACE,gBAAA;AAvDF;;AAyDA;EACE,iBAAA;EACA,oBAAA;AAtDF;AAzYI;EA6bJ;IAII,eAAA;IACA,gCAAA;IACA,OAAA;IACA,QAAA;IACA,aAAA;IACA,aAAA;IACA,iBAAA;IACA,oBAAA;EApDF;AACF;AAjZI;EAybJ;IAcI,iBAAA;IACA,oBAAA;EAlDF;AACF;AAmDE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAjDJ;AAmDI;EACE,qBAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;EAgBA,qBAAA;AAhEN;AAiDM;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;AA/CR;AAiDM;EACE,qBAAA;EACA,WAAA;AA/CR;AAjbI;EA8dE;IAII,WAAA;EA7CR;AACF;AAlbI;EA0dE;IAOI,WAAA;EA3CR;AACF;AA3bI;EAmdA;IAuBI,eAAA;EA3CN;AACF;AA5bI;EA+cA;IA0BI,eAAA;EAzCN;AACF;AA4CI;EACE,eAAA;EACA,gBAAA;AA1CN;AAzcI;EAifA;IAII,eAAA;EAxCN;AACF;AA0CI;EACE,aAAA;EACA,WAAA;AAxCN;AAldI;EAwfA;IAII,iBAAA;IACA,WAAA;IACA,eAAA;IACA,WAAA;IACA,SAAA;IACA,MAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAlhBD;EA4eL;EAwCM;IACE,OAAA;EAtCR;EAwCM;IACE,cAAA;EAtCR;AACF;AAzeI;EA6gBI;IAGI,cAAA;EAnCV;AACF;AA1eI;EAofA;IA6BI,eAAA;IACA,WAAA;IACA,UAAA;IACA,MAAA;IACA,sBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,yBAxiBD;EAqgBL;EAoCM;IACE,OAAA;IACA,iBAAA;EAlCR;EAoCM;IACE,cAAA;EAlCR;AACF;AAsCM;EACE,cAAA;AApCR;AAsCM;EACE,cAAA;EACA,gCAAA;EACA,oBAAA;AApCR;AAvgBI;EAoiBA;IAUI,cAAA;EAnCN;AACF;AAoCM;EACE,qBAAA;EACA,kBAAA;AAlCR;AAmCQ;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,aAAA;EACA,OAAA;EACA,uBAAA;EACA,8BAAA;EACA,oCAAA;AAjCV;AAmCQ;EACE,oBAAA;EACA,6BAAA;AAjCV;AAsCI;EACE,aAAA;EACA,eAAA;AApCN;AAqCM;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,gCAAA;EACA,uBAAA;AAnCR;AAoCQ;EACE,UAAA;AAlCV;AA/iBI;EAykBE;IAWI,WAAA;EAjCR;AACF;AAxjBI;EA0kBA;IAkBI,cAAA;EAhCN;EAkCM;IACE,UAAA;IACA,4CAAA;EAhCR;EAkCM;IACE,UAAA;EAhCR;EAkCM;IACE,8CAAA;EAhCR;AACF;AAnkBI;EAskBA;IAgCI,cAAA;EA/BN;EAiCM;IACE,UAAA;IACA,4CAAA;EA/BR;EAiCM;IACE,UAAA;EA/BR;EAiCM;IACE,8CAAA;EA/BR;AACF;;AAqCA;EACE,yBAtoBK;AAomBP;AAmCE;EACE,oBAAA;AAjCJ;AAoCE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,SAAA;AAlCJ;AApmBI;EAioBF;IAQI,SAAA;IACA,iBAAA;IACA,oBAAA;IACA,sBAAA;EAjCJ;AACF;AAmCI;EACE,MAAA;AAjCN;AA/mBI;EA+oBA;IAGI,SAAA;EA/BN;AACF;AAkCI;EACE,SAAA;AAhCN;AAkCM;EACE,kCAtqBE;EAuqBF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;AAhCR;AAhoBI;EAypBE;IAUI,eAAA;EA/BR;AACF;AAjoBI;EAqpBE;IAaI,eAAA;EA7BR;AACF;AA+BM;EACE,kCAtrBE;EAurBF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA7BR;AA+BM;EACE,kCAjsBE;EAksBF,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AA7BR;AA+BM;EACE,gBAAA;EACA,kCAAA;EACA,YAAA;EACA,eAAA;AA7BR;AArqBI;EA8rBE;IAMI,eAAA;IACA,eAAA;EA3BR;AACF;AAvqBI;EA0rBE;IAUI,eAAA;EAzBR;AACF;AA4BM;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCA5tBE;EA6tBF,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;AA1BR;AA2BQ;EACE,cAjuBH;EAkuBG,uBAAA;EACA,uBAAA;EACA,gCAAA;AAzBV;AAjsBI;EA4sBE;IAiBI,kBAAA;IACA,eAAA;IACA,uBAAA;EAxBR;AACF;AAxsBI;EAmuBI;IACE,eAAA;EAxBR;AACF;AA2BI;EACE,SAAA;AAzBN;AA0BM;EACE,UAAA;EACA,iBAAA;AAxBR;AAptBI;EA0uBE;IAII,UAAA;IACA,YAAA;EAtBR;AACF;AAttBI;EAsuBE;IAQI,WAAA;IACA,YAAA;EApBR;AACF;AAxtBI;EAmnBJ;IA8HI,8BAAA;IACA,iCAAA;EArBF;AACF;AAtuBI;EA2nBJ;IAkII,sBAAA;EAnBF;AACF;;AAqBA;EACE,yBAAA;AAlBF;AAmBE;EACE,iBAAA;EACA,oBAAA;AAjBJ;AAnvBI;EAkwBF;IAII,iBAAA;EAfJ;AACF;AAgBI;EACE,kCArxBI;EAsxBJ,eAAA;EACA,mBAAA;EACA,cAtxBC;EAuxBD,gBAAA;EACA,gBAAA;AAdN;AAhwBI;EAwwBA;IASI,eAAA;EAbN;AACF;AAeI;EACE,kCAjyBI;EAkyBJ,eAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AAbN;AA5wBI;EAoxBA;IAQI,eAAA;EAZN;AACF;AAcI;EACE,kCA5yBI;EA6yBJ,eAAA;EACA,mBAAA;EACA,cA7yBC;EA8yBD,gBAAA;AAZN;AAxxBI;EA+xBA;IAQI,eAAA;EAXN;AACF;AAcI;EACE,kCAxzBI;EAyzBJ,mBAAA;EACA,gBAAA;AAZN;AAlyBI;EA2yBA;IAKI,gBAAA;EAVN;AACF;AAcM;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,mBAAA;AAZR;AA7yBI;EAqzBE;IAMI,kBAAA;EAVR;AACF;AAWQ;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;AATV;AA1zBI;EA6zBI;IAQI,aAAA;EAPV;AACF;AAUQ;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;AARV;AAr0BI;EAy0BI;IAMI,gBAAA;IACA,mBAAA;IACA,eAAA;EANV;AACF;AAQQ;EACE,qBAAA;EACA,kBAAA;EACA,kCAn2BA;EAo2BA,eAAA;EACA,uBAAA;EACA,mBAAA;AANV;AAOU;EACE,cAt2BL;EAu2BK,uBAAA;EACA,uBAAA;EACA,gCAAA;AALZ;AA11BI;EAo1BI;IAcI,kBAAA;IACA,eAAA;IACA,uBAAA;EAJV;AACF;AAOQ;EACE,yDAAA;EACA,4BAAA;EACA,2BAAA;AALV;AAt2BI;EAw2BI;IAKI,oBAAA;IACA,2BAAA;EAHV;AACF;AAKQ;EACE,yDAAA;EACA,4BAAA;EACA,4BAAA;EACA,sBAAA;EACA,uBAAA;AAHV;AAIU;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;AAFZ;AA33BI;EAu3BM;IAQI,aAAA;EAAZ;AACF;AAEU;EACE,eAAA;EACA,gBAAA;AAAZ;AAp4BI;EAk4BM;IAII,eAAA;EAEZ;AACF;AAz4BI;EAi3BI;IA0BI,oBAAA;EAEV;AACF;AAEM;EACE,gBAAA;AAAR;AAEQ;EACE,SAAA;AAAV;AACU;EACE,aAAA;AACZ;AAv5BI;EA45BA;IAEI,mBAAA;EAHN;AACF;AAIM;EACE,kCA76BE;EA86BF,eAAA;EACA,gBAAA;AAFR;AAGQ;EACE,cA/6BH;EAg7BG,gBAAA;AADV;AAEU;EACE,cAAA;EACA,gCAAA;AAAZ;AAIM;EACE,gBAAA;AAFR;AA56BI;EA66BE;IAGI,gBAAA;EAAR;AACF;AACQ;EACE,cAAA;EACA,kCAh8BA;EAi8BA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,6BAAA;EACA,cAp8BH;EAq8BG,mBAAA;AACV;AAAU;EACE,YAAA;EACA,yBAx8BL;EAy8BK,yBAAA;EACA,gCAAA;AAEZ;AAl8BI;EAk7BI;IAiBI,kBAAA;IACA,eAAA;IACA,yBAAA;EAGV;AACF;AACI;EACE,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,yDAAA;EACA,4BAAA;EACA,4BAAA;AAAN;AAn9BI;EA08BA;IAYI,kBAAA;IACA,oBAAA;IACA,4BAAA;EACN;AACF;AAt9BI;EAs8BA;IAiBI,oBAAA;EAGN;AACF;AAFM;EACE,cAx+BD;EAy+BC,kCA3+BE;EA4+BF,eAAA;AAIR;AAp+BI;EA69BE;IAKI,eAAA;IACA,mBAAA;EAMR;AACF;AAJM;EACE,cAj/BD;EAm/BC,gBAAA;EACA,kBAAA;EACA,cAAA;AAKR;AAh/BI;EAs+BE;IAOI,eAAA;EAOR;AACF;AALM;EACE,cAAA;EACA,kBAAA;EACA,kCA//BE;EAggCF,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAlgCD;AAygCP;AALQ;EACE,YAAA;EAEA,yBAvgCH;EAygCG,yBAAA;EACA,gCAAA;AAKV;AArgCI;EAg/BE;IAmBI,kBAAA;IACA,eAAA;EAMR;AACF;;AACE;EACE,iBAAA;EACA,oBAAA;AAEJ;AAAM;EACE,kCA7hCE;EA8hCF,eAAA;EACA,mBAAA;EACA,cA9hCD;EA+hCC,gBAAA;AAER;AAvhCI;EAghCE;IAQI,eAAA;EAGR;AACF;AADM;EACE,kCAxiCE;EAyiCF,mBAAA;EACA,gBAAA;AAGR;AACM;EACE,gBAAA;EACA,kCAhjCE;EAijCF,qBAAA;EACA,gBAAA;EACA,cAjjCD;EAkjCC,gBAAA;AACR;AACM;EACE,kCAvjCE;EAwjCF,mBAAA;EACA,gBAAA;AACR;;AAIA;EACE,sBAAA;EACA,YAAA;AADF;;AAGA;EACE,yBAAA;AAAF;;AAEA;EACE,yBAAA;AACF;;AAGE;EACE,iBAAA;EACA,oBAAA;AAAJ;AACI;EACE,kCA9kCI;EA+kCJ,eAAA;EACA,mBAAA;EACA,cA/kCC;EAglCD,gBAAA;AACN;AAvkCI;EAikCA;IAQI,eAAA;EAEN;AACF;AAAI;EACE,kCAzlCI;EA0lCJ,mBAAA;EACA,gBAAA;AAEN;;AAGA;EAjkCE,aAAA;AAskCF;AAjlCI;EA4kCJ;IAGI,SAAA;EAMF;EALE;IACE,eAAA;EAOJ;AACF;AAjmCI;EAolCJ;IASI,sBAAA;IACA,aAAA;EAQF;AACF;AAnmCI;EAglCJ;IAaI,sBAAA;IACA,aAAA;EAUF;AACF;;AAPA;EACE,iBAAA;EACA,oBAAA;AAUF;AAlnCI;EAsmCJ;IAII,iBAAA;IACA,oBAAA;EAYF;AACF;AAXE;EA1lCA,aAAA;EA4lCE,8BAAA;AAiBJ;AAhoCI;EA6mCF;IAKI,aAAA;EAkBJ;AACF;AAhBM;EACE,gBAAA;EACA,kCAnoCE;EAooCF,gBAAA;EACA,eAAA;AAkBR;AAhBM;EACE,kCAxoCE;EAyoCF,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;AAkBR;AAlpCI;EA2nCE;IAOI,kBAAA;IACA,eAAA;EAoBR;AACF;AAlBM;EACE,kCAnpCE;EAopCF,gBAAA;AAoBR;AA5pCI;EAsoCE;IAII,gBAAA;EAsBR;AACF;AAnBQ;EACE,WAAA;AAqBV;AApqCI;EA8oCI;IAGI,WAAA;EAuBV;AACF;;AAhBA,UAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;AAkBF;;AAfA;EArpCE,aAAA;EA0pCA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AAmBF;AApCE;EACE,eAAA;AAsCJ;AArBE;EACE,YAAA;AAuBJ;;AAnBA;EACE,gBAAA;EACA,cAAA;AAsBF;;AAlBE;EACE,qBAAA;AAqBJ;;AAjBA;EACE,kBAAA;AAoBF;AAlBE;EACE,eAAA;EACA,6BAAA;AAoBJ;AAnBI;EACE,0BAAA;AAqBN;AAlBE;EACE,8BAAA;AAoBJ;AAlBE;EACE,eAAA;EACA,mBAAA;EACA,kCAvuCM;AA2vCV;AAlBE;EACE,mBAAA;AAoBJ;AAlvCI;EAiuCA;IACE,eAAA;EAoBJ;AACF;;AAdA;EACE,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,cAAA;EACA,cAAA;AAiBF;AApwCI;EAyuCJ;IAYI,eAAA;EAmBF;AACF;;AAhBA;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kCA1wCQ;EA2wCR,WAAA;EACA,mBAAA;AAmBF;;AAjBA;EACE,UAAA;EACA,mBAAA;AAoBF;AAxxCI;EAkwCJ;IAII,WAAA;EAsBF;AACF;;AApBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAuBF;;AArBA;EACE,UAAA;AAwBF;;AAtBA;EACE,aAAA;AAyBF;;AAtBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;AAyBF;AApzCI;EAsxCJ;IAOI,WAAA;EA2BF;AACF;;AAxBA;EACE,gBAAA;EACA,kCA/yCQ;EAgzCR,mBAAA;AA2BF;;AAxBA;EACE,UAAA;EAEA,cAAA;EACA,kBAAA;EACA,kCAxzCQ;EAyzCR,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AA0BF;AAxBE;EACE,uBAAA;EAEA,yBAj0CG;EAm0CH,yBAAA;EACA,gCAAA;AAwBJ;AAl1CI;EAuyCJ;IAsBI,kBAAA;IACA,eAAA;EAyBF;AACF;;AAtBA;EACE,aAAA;AAyBF;;AAtBA,0BAAA;AACA;EACE,qBAAA;EACA,YAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAyBF;;AAvBA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AA0BF;;AAxBA;EACE,UAAA;EACA,kCAl2CQ;EAm2CR,eAAA;AA2BF;;AAvBA,uCAAA;AACA,uCAAA;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAyBF;;AAtBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;EACA,eAAA;AAyBF;;AAtBA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAyBF;;AAtBA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AAyBF;;AAtBA;EACE,cAAA;EACA,YAAA,EAAA,gCAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,wBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAyBF;;AAtBA;EACE,6BAAA;AAyBF;;AAtBA;EACE,kBAAA;EACA,kBAAA,EAAA,8BAAA;EACA,eAAA;AAyBF;;AAtBA,4BAAA;AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AAyBF;;AAtBA,yDAAA;AACA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AAyBF;;AAtBA,sDAAA;AACA;EACE,cAAA;AAyBF;;AAtBA,8BAAA;AACA;EACE,aAAA;AAyBF;;AAtBA;EACE,cAAA;EACA,YAAA;AAyBF;AAn9CI;EAw7CJ;IAII,eAAA;EA2BF;AACF;AA1BE;EACE,kCAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA4BJ;AAj+CI;EA87CF;IASI,eAAA;EA8BJ;AACF;AA5BE;EACE,gBAAA;AA8BJ;AAz+CI;EA08CF;IAGI,kBAAA;EAgCJ;AACF;AA/BI;EACE,mBAAA;EACA,kCA79CI;EA89CJ,gBAAA;AAiCN;AAn/CI;EA+8CA;IAMI,eAAA;EAkCN;AACF;;AA5BA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AA+BF;AA7BE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AA+BJ;AA7BE;EACE,YAAA;AA+BJ;AA7BE;EACE,WAAA;EACA,YAAA;AA+BJ;AA7gDI;EA4+CF;IAII,WAAA;EAiCJ;AACF;;AA7BA;EACE,yBAhgDK;EAigDL,uBAAA;AAgCF;;AA7BA;EACE,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAgCF;;AA7BA;EACE,sBAAA;EACA,mBAAA;AAgCF;;AA7BA;EACE,cAAA;EACA,YAAA;AAgCF;AA3BA;EACE,cAAA;EACA,kBAAA;AA6BF;AA7iDI;EA8gDJ;IAII,eAAA;IACA,gBAAA;EA+BF;AACF;;AA5BA;EACE,WAAA;EACA,YAAA;AA+BF;;AA5BA;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kCA7iDQ;EA8iDR,gBAAA;AA+BF;AA7BE;EACE,mBAAA;EACA,cAhjDG;EAijDH,kBAAA;EACA,kCApjDM;EAqjDN,gBAAA;EACA,eAAA;AA+BJ;AAzkDI;EAoiDF;IAQI,mBAAA;IAEA,eAAA;IACA,eAAA;EAgCJ;AACF;AAhlDI;EA4hDJ;IAwBI,UAAA;IACA,iBAAA;IACA,YAAA;EAgCF;AACF;AA9BE;EACE,cApkDG;EAqkDH,eAAA;EACA,iBAAA;EACA,mBAAA;AAgCJ;AA9BE;EACE,YAAA;EACA,gBAAA;AAgCJ;AA1BA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,kCAxlDQ;EAylDR,gCAAA;AA4BF;AAzmDI;EAukDJ;IAQI,mBAAA;EA8BF;AACF;;AA3BA;EACE,kCAhmDQ;EAimDR,iBAAA;AA8BF;;AA3BA;EACE,SAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA8BF;;AA5BA;EACE,yBAAA;AA+BF;;AA7BA;EACE,kCAhnDQ;AAgpDV;;AA7BA;EACE,iBAAA;EACA,YAAA;EACA,kCAtnDQ;EAunDR,0BAAA;EACA,iBAAA;EACA,mBAAA;AAgCF;AA5BA;EACE,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kCAloDQ;AAgqDV;AAppDI;EAinDJ;IAOI,iBAAA;IACA,oBAAA;EAgCF;AACF;AA9BE;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;AAgCJ;AA7BE;EACE,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AA+BJ;AA9BI;EACE,iBAAA;EACA,kCAtpDI;EAupDJ,yBAAA;AAgCN;AA9BI;EACE,cAxpDC;AAwrDP;AA9BI;EACE,eAAA;AAgCN;;AA5BA;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kCAtqDQ;EAuqDR,cArqDK;EAsqDL,kBAAA;EACA,yBAAA;AA+BF;AA5rDI;EAqpDJ;IAWI,kBAAA;EAgCF;AACF;;AA7BA;EACE,YAAA;EACA,kBAAA;AAgCF;;AA7BA;EACE,cAAA;EACA,kBAAA;EACA,kCAxrDQ;EAyrDR,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cA3rDK;EA4rDL,YAAA;EACA,mBAAA;AAgCF;AA9BE;EACE,YAAA;EACA,yBAjsDG;EAksDH,yBAAA;EACA,gCAAA;AAgCJ;AAztDI;EAyqDJ;IAmBI,kBAAA;IACA,eAAA;EAiCF;AACF;;AA9BA;EACE,uBAAA;EACA,cA7sDK;EA8sDL,mBAAA;AAiCF;;AA/BA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;AAkCF;AAjCE;EACE,qBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;AAmCJ;AArvDI;EA4sDF;IAQI,kBAAA;IACA,SAAA;IACA,YAAA;EAqCJ;AACF;;AAlCA;EACE,qBAAA;EACA,6BAAA;EACA,SAAA;EAEA,gCAAA;EACA,yBAAA;AAqCF;AArwDI;EA0tDJ;IAQI,WAAA;EAuCF;AACF;;AArCA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;AAwCF;AAtxDI;EAquDJ;IAWI,QAAA;IACA,UAAA;EA0CF;AACF;;AAvCA;EACE,kBAAA;AA0CF;AAzCE;EACE,oBAAA;AA2CJ;AAnyDI;EAuvDF;IAGI,oBAAA;EA6CJ;AACF;AApyDI;EAmvDF;IAMI,qBAAA;EA+CJ;AACF;AA7CE;EACE,kBAAA;AA+CJ;AAhzDI;EAgwDF;IAGI,kBAAA;EAiDJ;AACF;AA/CE;EACE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,QAAA,EAAA,sEAAA;EACA,SAAA,EAAA,sEAAA;EAEA,gCAAA;EACA,UAAA;AAgDJ;AA/zDI;EAswDF;IAWI,QAAA,EAAA,sEAAA;IACA,SAAA,EAAA,sEAAA;IACA,WAAA;IACA,gCAAA;EAkDJ;AACF;AAn0DI;EAkwDF;IAiBI,QAAA;EAoDJ;AACF;;AA/CE;EACE,UAAA;AAkDJ;AAhDE;EACE,yBAAA;EACA,iBAAA;EACA,oBAAA;AAkDJ;AAhDI;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;AAkDN;AA51DI;EAqyDA;IAOI,aAAA;IACA,sBAAA;EAoDN;AACF;AAnDM;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,kCA/zDE;AAo3DV;AAx2DI;EA+yDE;IAMI,eAAA;EAuDR;AACF;AArDM;EACE,SAAA;AAuDR;AAtDQ;EACE,YAAA;EACA,kCAx0DA;EAy0DA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAwDV;AApDU;EACE,oBAAA;AAsDZ;AAjDI;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,qDAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;AAmDN;AAr4DI;EA00DA;IAUI,sBAAA;IACA,aAAA;IACA,gBAAA;EAqDN;AACF;AApDM;EACE,kCAr2DE;EAs2DF,eAAA;EACA,cAAA;EACA,SAAA;AAsDR;AAl5DI;EAw1DE;IAMI,eAAA;EAwDR;AACF;AAtDM;EACE,SAAA;AAwDR;AAtDU;EACE,mBAAA;EACA,kCAl3DF;EAm3DE,mBAAA;AAwDZ;AA/5DI;EAo2DM;IAKI,kBAAA;EA0DZ;AACF;AAp6DI;EA22DQ;IAEI,mBAAA;EA2Dd;AACF;AAxDY;EACE,cA53DP;EA63DO,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AA0Dd;AAh7DI;EAi3DQ;IAOI,eAAA;IACA,gBAAA;EA4Dd;AACF;AA1DY;EACE,eAAA;EACA,gBAAA;AA4Dd;AA17DI;EA43DQ;IAII,eAAA;EA8Dd;AACF;AA7Dc;EACE,cA74DT;EA84DS,gBAAA;AA+DhB;AA7DgB;EACE,cAAA;EACA,gCAAA;AA+DlB;AAzDQ;EACE,mBAAA;AA2DV;AA1DU;EACE,mBAAA;AA4DZ;AA3DY;EACE,yBA75DP;EA85DO,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,kCAz6DJ;EA06DI,mBAAA;EACA,eAAA;AA6Dd;AA59DI;EAk5DQ;IAeI,eAAA;EA+Dd;AACF;AA7DY;EACE,aAAA;EACA,yBAAA;EACA,kCAn7DJ;EAo7DI,eAAA;EACA,+BAAA;EACA,gCAAA;EACA,iDAAA;AA+Dd;AA1+DI;EAo6DQ;IASI,eAAA;EAiEd;AACF;AA5DU;EACE,aAAA;EACA,kBAAA;AA8DZ;AA7DY;EACE,SAAA;AA+Dd;AA7DY;EACE,SAAA;AA+Dd;;AAnDA;EACE,kBAAA;EACA,qBAAA;EACA,yBAAA;AAsDF;AArDE;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,SAAA;AAuDJ;AArDI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,6BAAA;EACA,eAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;AAuDN;AArDM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,kCAAA;AAuDR;AApDM;EACE;IACE,yBAAA;EAsDR;AACF;AAlDI;EACE,aAAA;EACA,cA3/DC;EA4/DD,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qDAAA;EACA,mBAAA;AAoDN;AAnDM;EACE,kCAvgEE;EAwgEF,eAAA;EACA,gBAAA;AAqDR;AAnDM;EACE,kCA5gEE;EA6gEF,eAAA;EACA,kBAAA;EACA,gBAAA;AAqDR;AAxjEI;EAs8DJ;IAmEI,qBAAA;EAmDF;EAlDE;IACE,sBAAA;EAoDJ;EAlDI;IACE,aAAA;EAoDN;EAnDM;IACE,eAAA;EAqDR;EAnDM;IACE,eAAA;EAqDR;AACF;;AA/CA;EACE,yBAAA;EACA,eAAA;EACA,oBAAA;AAkDF;AA/kEI;EA0hEJ;IAKI,oBAAA;EAoDF;AACF;AAplEI;EA0hEJ;IAQI,kBAAA;IACA,mBAAA;EAsDF;AACF;AArDE;EACE,kBAAA;EACA,yBAjjEG;EAkjEH,kBAAA;EACA,mBAAA;AAuDJ;AAhmEI;EAqiEF;IAOI,kBAAA;EAwDJ;AACF;AAvDI;EACE,kBAAA;EACA,MAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AAyDN;AA7mEI;EA8iEA;IAQI,WAAA;IACA,UAAA;IACA,WAAA;EA2DN;AACF;AAzDI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;AA2DN;AA1nEI;EA2jEA;IAMI,WAAA;IACA,aAAA;EA6DN;AACF;AA1DI;EACE,kCAnlEI;EAolEJ,eAAA;EACA,YAAA;EACA,gBAAA;AA4DN;AA1DI;EACE,YAAA;EACA,kCA1lEI;EA2lEJ,eAAA;EACA,gBAAA;EACA,gBAAA;AA4DN;;AAvDA;EACE,uBAAA;EACA,eAAA;AA0DF;AAzDE;EACE,kCAtmEM;EAumEN,eAAA;EACA,cAtmEG;EAumEH,0BAAA;EACA,mBAAA;EACA,gBAAA;AA2DJ;AA1pEI;EAslEJ;IAYI,eAAA;EA4DF;AACF;AA3DE;EACE,aAAA;EACA,SAAA;AA6DJ;AA3DI;EACE,kBAAA;EACA,qBAAA;EACA,SAAA;AA6DN;AAxqEI;EAwmEA;IAKI,qBAAA;EA+DN;AACF;AA7DM;EACE,kCA7nEE;EA8nEF,eAAA;EACA,gBAAA;EACA,mBAAA;AA+DR;AAnrEI;EAgnEE;IAMI,mBAAA;EAiER;AACF;AA/DM;EACE,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,uBAAA;AAgER;AAjsEI;EAynEE;IAUI,aAAA;EAkER;AACF;AAjEQ;EACE,gBAAA;EACA,WAAA;AAmEV;AAjEQ;EACE,oBAAA;EACA,WAAA;AAmEV;AAjEQ;EACE,sBAAA;EACA,WAAA;AAmEV;AA5DI;EACE,SAAA;EACA,mBAAA;AA8DN;AA7DM;EACE,mBAAA;AA+DR;AA7DM;EACE,yBAvqED;EAwqEC,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,kCAnrEE;EAorEF,mBAAA;EACA,eAAA;EACA,gBAAA;AA+DR;AAzuEI;EA4pEE;IAiBI,eAAA;EAgER;AACF;AA9DM;EACE,aAAA;EACA,yBAAA;EACA,kCA/rEE;EAgsEF,eAAA;EACA,+BAAA;EACA,gCAAA;EACA,iDAAA;EACA,yBAAA;EACA,gBAAA;AAgER;AAzvEI;EAgrEE;IAWI,eAAA;EAkER;AACF;AA9vEI;EAomEF;IA6FI,sBAAA;EAiEJ;AACF;;AA5DA;EACE,yBAAA;EACA,eAAA;AA+DF;AAxwEI;EAusEJ;IAII,eAAA;EAiEF;AACF;AA/DI;EACE,aAAA;AAiEN;AAhxEI;EA8sEA;IAGI,sBAAA;EAmEN;AACF;AAlEM;EACE,SAAA;EACA,kCAjuEE;EAkuEF,eAAA;EACA,cAjuED;EAkuEC,gBAAA;AAoER;AA5xEI;EAmtEE;IAOI,mBAAA;EAsER;AACF;AApEM;EACE,SAAA;EACA,kCA3uEE;AAizEV;AAnEI;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,gBAAA;AAqEN;AA3yEI;EAkuEA;IAMI,eAAA;IACA,SAAA;IACA,qCAAA;IACA,SAAA;EAuEN;AACF;AA/yEI;EA8tEA;IAYI,eAAA;IACA,gBAAA;IACA,qCAAA;EAyEN;AACF;AAvEM;EACE,kBAAA;EACA,mBAAA;EACA,iDAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EAEA,eAAA;AAwER;AAv0EI;EAmvEE;IAeI,aAAA;IACA,iBAAA;IACA,SAAA;EAyER;AACF;AA10EI;EA+uEE;IAoBI,aAAA;IACA,gBAAA;EA2ER;AACF;AAzEQ;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kCA3xEA;EA4xEA,sBAAA;AA2EV;AAxEQ;EACE,gBAAA;EAEA,aAAA;EACA,sBAAA;EACA,UAAA;AAyEV;AAvEQ;EACE,kCAvyEA;EAwyEA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AAyEV;AA12EI;EA0xEI;IASI,gBAAA;IACA,eAAA;EA2EV;AACF;AAzEQ;EACE,gBAAA;EACA,gEAAA;EACA,UAAA;AA2EV;AAr3EI;EAuyEI;IAKI,YAAA;IACA,gBAAA;EA6EV;AACF;AA3EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA6EV;AA3EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA6EV;AA3EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA6EV;AA3EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA6EV;AA3EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA6EV;AA1EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA4EV;AA1EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA4EV;AA1EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA4EV;AA1EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA4EV;AA1EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA4EV;AA1EQ;EACE,YAAA;EACA,aAAA;EACA,0DAAA;EACA,4BAAA;EACA,2BAAA;AA4EV;AAzEQ;EACE,oBAAA;AA2EV;AA1EU;EACE,YAAA;AA4EZ;AA1EU;EACE,oBAAA;EACA,wBAAA;EACA,cAj5EL;AA69EP;AAzEU;EACE,0DAAA;AA2EZ;AAxEU;EACE,0DAAA;AA0EZ;AAvEU;EACE,0DAAA;AAyEZ;AAtEU;EACE,0DAAA;AAwEZ;AArEU;EACE,0DAAA;AAuEZ;AApEU;EACE,0DAAA;AAsEZ;AAnEU;EACE,0DAAA;AAqEZ;AAlEU;EACE,0DAAA;AAoEZ;AAjEU;EACE,0DAAA;AAmEZ;AAhEU;EACE,0DAAA;AAkEZ;AA/DU;EACE,0DAAA;AAiEZ;AAp/EI;EAkuEA;IAuNI,sBAAA;IACA,kBAAA;EA+DN;AACF","sourcesContent":["@font-face {\n  font-family: \"Roboto Mono It\";\n  src: url(\"../fonts/RobotoMono-Italic.woff2\") format(\"woff2\"),\n    url(\"../fonts/RobotoMono-Italic.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Roboto Mono Regular\";\n  src: url(\"../fonts/RobotoMono-Regular.woff2\") format(\"woff2\"),\n    url(\"../fonts/RobotoMono-Regular.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"../fonts/Montserrat-Thin.woff2\") format(\"woff2\"),\n    url(\"../fonts/Montserrat-Thin.woff\") format(\"woff\");\n  font-weight: 100;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* VARIABLES */\n\n$mont: \"Montserrat\";\n$regular: \"Roboto Mono Regular\";\n$italic: \"Roboto Mono It\";\n$blue: #3b20e2;\n\n/* MIXINS */\n\n@mixin mq($size) {\n  @if $size==xs {\n    @media (max-width: 320px) {\n      @content;\n    }\n  } @else if $size==mobile {\n    @media (max-width: 767px) {\n      @content;\n    }\n  } @else if $size==tab {\n    @media only screen and (min-width: 768px) and (max-width: 1024px) {\n      @content;\n    }\n  } @else if $size==desktop {\n    @media only screen and (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin flexbox {\n  display: -webkit-box; // old\n  display: -moz-box; // old\n  display: -ms-flexbox; // ie\n  display: -webkit-flex; // new\n  display: flex; // new\n}\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  $opacity-ie: $opacity * 100;\n  filter: alpha(opacity=$opacity-ie); //IE8\n}\n\n@mixin input-placeholder {\n  &.placeholder {\n    @content;\n  }\n  &:-moz-placeholder {\n    @content;\n  }\n  &::-moz-placeholder {\n    @content;\n  }\n  &:-ms-input-placeholder {\n    @content;\n  }\n  &::-webkit-input-placeholder {\n    @content;\n  }\n}\n\n/* RESET CSS */\n\n/* http://meyerweb.com/eric/tools/css/reset/\n         v2.0 | 20110126\n         License: none (public domain)\n      */\n\nhtml,\nbody,\ndiv,\nspan,\napplet,\nobject,\niframe,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np,\nblockquote,\npre,\na,\nabbr,\nacronym,\naddress,\nbig,\ncite,\ncode,\ndel,\ndfn,\nem,\nimg,\nins,\nkbd,\nq,\ns,\nsamp,\nsmall,\nstrike,\nstrong,\nsub,\nsup,\ntt,\nvar,\nb,\nu,\ni,\ncenter,\ndl,\ndt,\ndd,\nol,\nul,\nli,\nfieldset,\nform,\nlabel,\nlegend,\ntable,\ncaption,\ntbody,\ntfoot,\nthead,\ntr,\nth,\ntd,\narticle,\naside,\ncanvas,\ndetails,\nembed,\nfigure,\nfigcaption,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\noutput,\nruby,\nsection,\nsummary,\ntime,\nmark,\naudio,\nvideo {\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nhgroup,\nmenu,\nnav,\nsection {\n  display: block;\n}\nbody {\n  line-height: 1;\n}\nol,\nul {\n  list-style: none;\n}\nblockquote,\nq {\n  quotes: none;\n}\nblockquote:before,\nblockquote:after,\nq:before,\nq:after {\n  content: \"\";\n  content: none;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n* {\n  box-sizing: border-box;\n}\n\na {\n  &,\n  &:hover,\n  &:active,\n  &:visited,\n  &:focus {\n    color: inherit;\n  }\n\n  text-decoration: none;\n}\n\ni,\nem,\n.italic-text {\n  font-style: italic;\n}\n\n.left {\n  float: left;\n}\n.right {\n  float: right;\n}\n\n.wrap-clear::after {\n  content: \"\";\n  display: block;\n  clear: both;\n}\n.clearfix {\n  zoom: 1;\n  display: table;\n  clear: both;\n\n  &:before,\n  &:after {\n    content: \"\";\n    display: table;\n  }\n\n  &:after {\n    clear: both;\n  }\n}\n\n:focus {\n  outline: none;\n}\n\ninput,\nbutton,\ntextarea {\n  border-radius: 0;\n  appearance: none;\n}\n\nselect {\n  border-radius: 0;\n}\n\ntextarea {\n  resize: none;\n}\n\n/* COMMONS */\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  letter-spacing: 0.6px;\n}\n\nol,\nul {\n  margin: 0px;\n}\n\nbutton,\ninput,\nselect,\ntextarea {\n  -webkit-appearance: none;\n  appearance: none;\n  outline: none;\n  border-radius: 0;\n  background-color: transparent;\n}\n\ninput,\ntextarea {\n  background: transparent;\n  border: none;\n}\n\ninput:focus,\nselect:focus,\ntextarea:focus,\nbutton:focus,\na:focus {\n  outline: none;\n}\n\na {\n  color: inherit;\n  cursor: pointer;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\nh1,\nh2,\nh3,\nh4 {\n  line-height: 1.2;\n}\n\np {\n  line-height: 1.3;\n}\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.slick-next:before,\n.slick-prev:before {\n  content: \"\";\n}\n\n.scroll-lock {\n  height: 100%;\n  overflow-y: hidden;\n\n  @include mq(mobile) {\n    // overflow-y: visible;\n  }\n}\n\nsmall {\n  font-size: 13px;\n}\n\n.input[type=\"checkbox\"] {\n  -webkit-appearance: checkbox;\n  appearance: checkbox;\n  box-sizing: border-box;\n}\nhtml {\n  scroll-behavior: smooth;\n}\n\n.hidden-lg {\n  @include mq(desktop) {\n    display: none !important;\n  }\n}\n.hidden-xs {\n  @include mq(mobile) {\n    display: none !important;\n  }\n}\n.hidden-md {\n  @include mq(tab) {\n    display: none !important;\n  }\n}\n\n.img-responsive {\n  width: 100%;\n  height: auto;\n}\n\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  width: 90%;\n\n  @include mq(tab) {\n    width: 90%;\n    max-width: 768px;\n    margin: 0 auto;\n  }\n  @include mq(mobile) {\n    width: 100%;\n    padding: 0 20px;\n    margin: 0 auto;\n  }\n}\n// common\n.common-bg {\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\np {\n  font-size: 15px;\n  @include mq(mobile) {\n    font-size: 15px;\n  }\n}\n\nh2 {\n  font-weight: 600;\n}\nmain {\n  @include mq(mobile) {\n    padding-top: 65px;\n  }\n}\nheader {\n  background-color: #3b20e2;\n  .logo {\n    color: white;\n    font-family: $regular;\n    font-size: 26px;\n    line-height: 1.2;\n  }\n  a {\n    color: white;\n    font-family: $regular;\n    display: inline-block;\n    font-size: 19px;\n    line-height: 1.2;\n  }\n  .navbar {\n    padding-top: 32px;\n    padding-bottom: 32px;\n    @include flexbox();\n    justify-content: space-between;\n    .nav {\n      display: flex;\n      column-gap: 60px;\n      align-items: flex-start;\n      .nav-item {\n        padding-bottom: 5px;\n        color: white;\n        &.active {\n          color: #f6fe01;\n          border-bottom: #f6fe01 solid 1px;\n        }\n      }\n    }\n  }\n}\n#navbar {\n  transition: 0.7s;\n}\nheader {\n  padding-top: 30px;\n  padding-bottom: 15px;\n  @include mq(mobile) {\n    position: fixed;\n    transition: top 0.6s ease-in-out;\n    left: 0;\n    right: 0;\n    z-index: 5000;\n    z-index: 5000;\n    padding-top: 15px;\n    padding-bottom: 15px;\n  }\n  @include mq(tab) {\n    padding-top: 15px;\n    padding-bottom: 10px;\n  }\n  .header-main {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    a {\n      display: inline-block;\n      font: 18px $regular;\n      color: white;\n      display: block;\n      border-bottom: 1px solid transparent;\n      #logo-brand {\n        transition: 0.6s;\n        font-size: 26px;\n        line-height: 1.2;\n      }\n      img {\n        display: inline-block;\n        width: 80px;\n        @include mq(mobile) {\n          width: 60px;\n        }\n        @include mq(tab) {\n          width: 61px;\n        }\n      }\n      display: inline-block;\n      @include mq(mobile) {\n        font-size: 20px;\n      }\n      @include mq(tab) {\n        font-size: 24px;\n      }\n    }\n\n    .brand {\n      font-size: 26px;\n      line-height: 1.2;\n      @include mq(mobile) {\n        font-size: 22px;\n      }\n    }\n    .nav-menu {\n      display: flex;\n      gap: 2.5rem;\n      @include mq(mobile) {\n        padding-top: 80px;\n        z-index: -1;\n        position: fixed;\n        left: -100%;\n        top: 70px;\n        gap: 0;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        text-align: center;\n        transition: 0.3s;\n        overflow: hidden;\n        background-color: $blue;\n\n        &.active {\n          left: 0;\n        }\n        .nav-item {\n          margin: 16px 0;\n          @include mq(mobile) {\n            margin: 10px 0;\n          }\n        }\n      }\n      @include mq(tab) {\n        position: fixed;\n        left: -100%;\n        top: 100px;\n        gap: 0;\n        flex-direction: column;\n        width: 100%;\n        min-height: 100vh;\n        text-align: center;\n        transition: 0.3s;\n        background-color: $blue;\n        &.active {\n          left: 0;\n          padding-top: 3rem;\n        }\n        .nav-item {\n          margin: 10px 0;\n        }\n      }\n    }\n    .nav-item {\n      &:hover {\n        color: #f6fe01;\n      }\n      &.active {\n        color: #f6fe01;\n        border-bottom: 1px solid #f6fe01;\n        padding-bottom: 10px;\n      }\n      @include mq(tab) {\n        line-height: 2;\n      }\n      .nav-link {\n        display: inline-block;\n        position: relative;\n        &:after {\n          content: \"\";\n          position: absolute;\n          width: 100%;\n          transform: scaleX(0);\n          height: 2px;\n          bottom: -18px;\n          left: 0;\n          background-color: white;\n          transform-origin: bottom right;\n          transition: transform 0.25s ease-out;\n        }\n        &:hover::after {\n          transform: scaleX(1);\n          transform-origin: bottom left;\n        }\n      }\n    }\n\n    .hamburger {\n      display: none;\n      cursor: pointer;\n      .bar {\n        display: block;\n        width: 25px;\n        height: 3px;\n        margin: 5px auto;\n        transition: all 0.3s ease-in-out;\n        background-color: white;\n        &:nth-child(1) {\n          opacity: 0;\n        }\n        @include mq(tab) {\n          width: 35px;\n        }\n      }\n      @include mq(mobile) {\n        display: block;\n\n        &.active .bar:nth-child(1) {\n          opacity: 1;\n          transform: translate(0px, 8px) rotate(45deg);\n        }\n        &.active .bar:nth-child(2) {\n          opacity: 0;\n        }\n        &.active .bar:nth-child(3) {\n          transform: translate(0px, -8px) rotate(-45deg);\n        }\n      }\n      @include mq(tab) {\n        display: block;\n\n        &.active .bar:nth-child(1) {\n          opacity: 1;\n          transform: translate(0px, 8px) rotate(45deg);\n        }\n        &.active .bar:nth-child(2) {\n          opacity: 0;\n        }\n        &.active .bar:nth-child(3) {\n          transform: translate(0px, -8px) rotate(-45deg);\n        }\n      }\n    }\n  }\n}\n\n.banner {\n  background-color: $blue;\n  &.dlp-banner {\n    padding-bottom: 60px;\n  }\n\n  .wrapper {\n    display: flex;\n    justify-content: center;\n    padding-top: 60px;\n    padding-bottom: 60px;\n    gap: 4rem;\n\n    @include mq(mobile) {\n      gap: 2rem;\n      padding-top: 40px;\n      padding-bottom: 40px;\n      flex-direction: column;\n    }\n\n    &.flex-donate {\n      gap: 0;\n      @include mq(mobile) {\n        gap: 2rem;\n      }\n    }\n\n    .flex-home {\n      flex: 3 1;\n\n      h1 {\n        font-family: $regular;\n        font-size: 60px;\n        line-height: 1.1;\n        font-weight: 700;\n        text-transform: capitalize;\n        color: white;\n        display: inline;\n\n        @include mq(mobile) {\n          font-size: 22px;\n        }\n        @include mq(tab) {\n          font-size: 33px;\n        }\n      }\n      h2 {\n        font-family: $regular;\n        font-size: 60px;\n        line-height: 1.1;\n        font-weight: 700;\n        text-transform: capitalize;\n        color: white;\n        background: #3b20e2;\n        display: inline;\n        line-height: 1.5;\n      }\n      h3 {\n        font-family: $regular;\n        font-size: 60px;\n        line-height: 1.1;\n        font-weight: 700;\n        text-transform: capitalize;\n        color: white;\n        background: #3b20e2;\n        display: inline;\n      }\n      p {\n        margin-top: 2rem;\n        font-family: \"Roboto Mono Regular\";\n        color: white;\n        font-size: 24px;\n        @include mq(mobile) {\n          max-width: 100%;\n          font-size: 16px;\n        }\n        @include mq(tab) {\n          font-size: 16px;\n        }\n      }\n\n      a {\n        margin-top: 2rem;\n        display: inline-block;\n        padding: 20px 40px;\n        font-family: $regular;\n        font-size: 24px;\n        border: 2px white solid;\n        border-radius: 10px;\n        color: white;\n        align-self: flex-start;\n        &:hover {\n          color: $blue;\n          background-color: white;\n          border: 2px white solid;\n          transition: 0.3s all ease-in-out;\n        }\n        @include mq(mobile) {\n          padding: 10px 20px;\n          font-size: 18px;\n          border: 1px white solid;\n        }\n      }\n      @include mq(mobile) {\n        h2 {\n          font-size: 36px;\n        }\n      }\n    }\n    .flex-img {\n      flex: 3 1;\n      .donate-hero-img {\n        width: 70%;\n        margin-left: auto;\n        @include mq(mobile) {\n          width: 70%;\n          margin: auto;\n        }\n        @include mq(tab) {\n          width: 100%;\n          margin: auto;\n        }\n      }\n    }\n  }\n  @include mq(desktop) {\n    border-top: 15px solid $blue;\n    border-bottom: 15px solid $blue;\n  }\n  @include mq(mobile) {\n    flex-direction: column;\n  }\n}\n.about {\n  background-color: #f5f5f5;\n  .wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    @include mq(mobile) {\n      padding-top: 40px;\n    }\n    .donate-copy-header {\n      font-family: $regular;\n      font-size: 30px;\n      margin-bottom: 1rem;\n      color: $blue;\n      line-height: 1.5;\n      font-weight: 600;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n    h2 {\n      font-family: $regular;\n      font-size: 41px;\n      margin-bottom: 1rem;\n      color: white;\n      line-height: 1.2;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n    h3 {\n      font-family: $regular;\n      font-size: 30px;\n      margin-bottom: 1rem;\n      color: $blue;\n      line-height: 1.5;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n\n    p {\n      font-family: $regular;\n      margin-bottom: 25px;\n      line-height: 1.5;\n      @include mq(mobile) {\n        line-height: 1.4;\n      }\n    }\n\n    .column-wrap {\n      .column {\n        padding: 50px;\n        background-color: #3b20e2;\n        color: white;\n        border-radius: 10px;\n        @include mq(mobile) {\n          padding: 35px 20px;\n        }\n        .copy-wrap-dl {\n          margin-top: 40px;\n          display: flex;\n          flex-direction: column;\n          justify-content: space-between;\n          height: 250px;\n          align-items: flex-start;\n          @include mq(mobile) {\n            height: unset;\n          }\n        }\n\n        .copy-delegation {\n          line-height: 1.4;\n          font-weight: unset;\n          margin-bottom: 40px;\n          font-size: 16px;\n          @include mq(mobile) {\n            margin-top: 20px;\n            margin-bottom: 20px;\n            font-size: 16px;\n          }\n        }\n        a {\n          display: inline-block;\n          padding: 20px 40px;\n          font-family: $regular;\n          font-size: 24px;\n          border: 2px white solid;\n          border-radius: 10px;\n          &:hover {\n            color: $blue;\n            background-color: white;\n            border: 2px white solid;\n            transition: 0.3s all ease-in-out;\n          }\n          @include mq(mobile) {\n            padding: 10px 20px;\n            font-size: 18px;\n            border: 1px white solid;\n          }\n        }\n\n        &.col-del {\n          background-image: url(\"../images/delegation.png\");\n          background-repeat: no-repeat;\n          background-position: 96% 4%;\n          @include mq(mobile) {\n            background-size: 28%;\n            background-position: 95% 4%;\n          }\n        }\n        &.col-liq {\n          background-image: url(\"../images/liquidity.png\");\n          background-repeat: no-repeat;\n          background-position: 95% 10%;\n          flex-direction: column;\n          align-items: flex-start;\n          .copy-wrap-dl {\n            margin-top: 40px;\n            display: flex;\n            flex-direction: column;\n            justify-content: space-between;\n            height: 250px;\n            align-items: flex-start;\n            @include mq(mobile) {\n              height: unset;\n            }\n          }\n          p {\n            font-size: 16px;\n            font-weight: 400;\n            @include mq(mobile) {\n              font-size: 16px;\n            }\n          }\n\n          @include mq(mobile) {\n            background-size: 28%;\n          }\n        }\n      }\n\n      &.column-wrap-2 {\n        margin-top: 30px;\n\n        .col-del {\n          flex: 1;\n          .copy-wrap-dl {\n            height: unset;\n          }\n        }\n      }\n    }\n\n    .column-wrap-page {\n      @include mq(mobile) {\n        padding-bottom: 0px;\n      }\n      p {\n        font-family: $regular;\n        font-size: 15px;\n        line-height: 1.5;\n        .link-a {\n          color: $blue;\n          font-weight: 700;\n          &:hover {\n            color: #08d0ae;\n            transition: all 0.2s ease-in-out;\n          }\n        }\n      }\n      .page-btn {\n        margin-top: 55px;\n        @include mq(mobile) {\n          margin-top: 30px;\n        }\n        a {\n          display: table;\n          font-family: $regular;\n          padding: 20px 40px;\n          font-size: 24px;\n          border: 2px $blue solid;\n          border-radius: 10px;\n          background-color: transparent;\n          color: $blue;\n          margin-bottom: 18px;\n          &:hover {\n            color: white;\n            background-color: $blue;\n            border: 2px $blue solid;\n            transition: 0.3s all ease-in-out;\n          }\n          @include mq(mobile) {\n            padding: 10px 20px;\n            font-size: 18px;\n            border: 1px $blue solid;\n          }\n        }\n      }\n    }\n    .donate {\n      margin-top: 20px;\n      background-color: white;\n      border-radius: 8px;\n      padding: 50px;\n      flex-direction: column;\n\n      background-image: url(\"../images/danate.png\");\n      background-repeat: no-repeat;\n      background-position: 96% 10%;\n\n      @include mq(mobile) {\n        padding: 35px 20px;\n        background-size: 45%;\n        background-position: 95% 10%;\n      }\n      @include mq(tab) {\n        background-size: 50%;\n      }\n      h2 {\n        color: $blue;\n        font-family: $regular;\n        font-size: 41px;\n        @include mq(mobile) {\n          font-size: 32px;\n          margin-bottom: 15px;\n        }\n      }\n      .copy-donate {\n        color: $blue;\n\n        line-height: 1.4;\n        font-weight: unset;\n        max-width: 40%;\n        @include mq(mobile) {\n          max-width: 100%;\n        }\n      }\n      a {\n        display: table;\n        padding: 20px 40px;\n        font-family: $regular;\n        font-size: 24px;\n        border: 2px $blue solid;\n        border-radius: 10px;\n        background-color: white;\n        color: $blue;\n\n        &:hover {\n          color: white;\n\n          background-color: $blue;\n\n          border: 2px $blue solid;\n          transition: 0.3s all ease-in-out;\n        }\n        @include mq(mobile) {\n          padding: 12px 22px;\n          font-size: 18px;\n        }\n      }\n    }\n  }\n}\n\n.description {\n  .wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    .title {\n      h2 {\n        font-family: $regular;\n        font-size: 30px;\n        margin-bottom: 1rem;\n        color: $blue;\n        line-height: 1.5;\n\n        @include mq(mobile) {\n          font-size: 25px;\n        }\n      }\n      p {\n        font-family: $regular;\n        margin-bottom: 1rem;\n        line-height: 1.5;\n      }\n    }\n    .copy {\n      h2 {\n        padding-top: 5px;\n        font-family: $regular;\n        margin-bottom: 0.5rem;\n        font-weight: 700;\n        color: $blue;\n        line-height: 1.5;\n      }\n      p {\n        font-family: $regular;\n        margin-bottom: 1rem;\n        line-height: 1.5;\n      }\n    }\n  }\n}\nfooter {\n  background-color: #000;\n  color: white;\n}\n.grey {\n  background-color: #f5f5f5;\n}\nhr {\n  border: 1px solid #c3bfbf;\n}\n\n.about1 {\n  .wrapper {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    h2 {\n      font-family: $regular;\n      font-size: 30px;\n      margin-bottom: 1rem;\n      color: $blue;\n      line-height: 1.5;\n\n      @include mq(mobile) {\n        font-size: 25px;\n      }\n    }\n    p {\n      font-family: $regular;\n      margin-bottom: 1rem;\n      line-height: 1.5;\n    }\n  }\n}\n\n.column-wrap {\n  @include flexbox();\n  @include mq(desktop) {\n    gap: 20px;\n    .column {\n      flex-basis: 50%;\n    }\n  }\n  @include mq(mobile) {\n    flex-direction: column;\n    row-gap: 20px;\n  }\n  @include mq(tab) {\n    flex-direction: column;\n    row-gap: 20px;\n  }\n}\n\nfooter {\n  padding-top: 50px;\n  padding-bottom: 50px;\n  @include mq(mobile) {\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n  .wrapper {\n    @include flexbox();\n    justify-content: space-between;\n\n    @include mq(mobile) {\n      row-gap: 20px;\n    }\n    .col {\n      .logo {\n        line-height: 1.2;\n        font-family: $regular;\n        font-weight: 700;\n        font-size: 24px;\n      }\n      .head {\n        font-family: $regular;\n        font-weight: 700;\n        font-size: 24px;\n        margin-bottom: 10px;\n        color: #807f80;\n        @include mq(mobile) {\n          margin-bottom: 5px;\n          font-size: 20px;\n        }\n      }\n      a {\n        font-family: $regular;\n        line-height: 1.9;\n        @include mq(mobile) {\n          line-height: 1.4;\n        }\n      }\n      .brand {\n        img {\n          width: 90px;\n          @include mq(mobile) {\n            width: 75px;\n          }\n        }\n      }\n    }\n  }\n}\n\n/* MODAL */\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n\n.modal-close-button {\n  span {\n    font-size: 26px;\n  }\n  @include flexbox();\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  font-size: 18px;\n  width: 22px;\n  height: 22px;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  background: #efefef;\n  border-radius: 50%;\n  color: gray;\n  &:hover {\n    color: black;\n  }\n}\n\n.qr-code {\n  max-width: 320px;\n  margin: 0 auto;\n}\n\n.container {\n  a {\n    word-wrap: break-word;\n  }\n}\n\n.qr-wallet {\n  text-align: center;\n\n  .wallet-tc {\n    font-size: 10px;\n    margin-bottom: 0px !important;\n    .hover-tc:hover {\n      text-decoration: underline;\n    }\n  }\n  .wallet-address {\n    margin-bottom: 10px !important;\n  }\n  h4 {\n    font-size: 22px;\n    margin-bottom: 20px;\n    font-family: $regular;\n  }\n  .qr-wrap {\n    margin-bottom: 20px;\n  }\n  @include mq(mobile) {\n    .wallet-address {\n      font-size: 11px;\n    }\n  }\n}\n\n// ? form\n\n.form-container {\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  margin: 0 auto;\n  max-width: 70%;\n  @include mq(mobile) {\n    max-width: 100%;\n  }\n}\n\n.form-input {\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  margin-bottom: 10px;\n  font-family: $regular;\n  width: 100%;\n  color: rgb(5, 5, 5);\n}\n.div-form {\n  width: 45%;\n  margin-bottom: 10px;\n  @include mq(mobile) {\n    width: 100%;\n  }\n}\n.class-checkbox {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n.wallet-ad {\n  width: 70%;\n}\n.div-tick {\n  display: flex;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  margin-bottom: 10px;\n  width: 80%;\n  justify-content: center;\n  @include mq(mobile) {\n    width: 100%;\n  }\n}\n\n.checkbox-group label {\n  margin-left: 5px;\n  font-family: $regular;\n  margin-bottom: 10px;\n}\n\n.submit-btn {\n  width: 60%;\n\n  display: table;\n  padding: 10px 30px;\n  font-family: $regular;\n  font-size: 16px;\n  border: 2px $blue solid;\n  border-radius: 10px;\n  background-color: white;\n  text-align: center;\n  color: $blue !important;\n\n  &:hover {\n    color: white !important;\n\n    background-color: $blue;\n\n    border: 2px $blue solid;\n    transition: 0.3s all ease-in-out;\n  }\n  @include mq(mobile) {\n    padding: 12px 22px;\n    font-size: 18px;\n  }\n}\n\ninput[type=\"checkbox\"] {\n  display: none;\n}\n\n/* Style the custom tick */\n.custom-tick {\n  display: inline-block;\n  width: 20fpx;\n  height: 16px;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  margin-right: 8px;\n}\n.custom-tick svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.error {\n  color: red;\n  font-family: $regular;\n  font-size: 12px;\n}\n\n// !\n/* styles.css (or any other CSS file) */\n/* styles.css (or any other CSS file) */\n\n.form-checkbox {\n  position: relative;\n  padding-left: 30px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.form-checkbox input {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.form-checkbox .checkmark {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.form-checkbox .checkmark::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n.form-checkbox input:checked + .checkmark::after {\n  display: block;\n  content: \"\\2713\"; /* Checkmark Unicode character */\n  background-image: url(\"../images/check-solid.svg\");\n  background-repeat: no-repeat;\n  background-position: right;\n  background-size: contain;\n  text-align: center;\n  line-height: 20px;\n  font-size: 24px;\n  color: transparent;\n}\n\n.form-checkbox input:required:not(:checked) + .checkmark {\n  border-color: rgb(76, 0, 255);\n}\n// ?/* Styling the custom checkbox container */\n.custom-checkbox {\n  position: relative;\n  padding-left: 25px; /* Space for the custom tick */\n  cursor: pointer;\n}\n\n/* Styling the custom tick */\n.custom-checkbox .checkbox-tick {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 20px;\n  width: 20px;\n  background-color: #fff;\n  border: 2px solid #333;\n  border-radius: 3px;\n}\n\n/* Styling the custom tick when the checkbox is checked */\n.custom-checkbox .checkbox-tick::after {\n  content: \"\";\n  position: absolute;\n  display: none;\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid #007bff;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n/* Show the custom tick when the checkbox is checked */\n.custom-checkbox input:checked + .checkbox-tick::after {\n  display: block;\n}\n\n/* Hide the default checkbox */\n.custom-checkbox input {\n  display: none;\n}\n// ? terms and condition\n.terms-c {\n  max-width: 60%;\n  margin: auto;\n  @include mq(mobile) {\n    max-width: 100%;\n  }\n  h2 {\n    font-family: \"Roboto Mono Regular\";\n    font-size: 30px;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    color: #3b20e2;\n    line-height: 1.5;\n    text-align: center;\n    @include mq(mobile) {\n      font-size: 20px;\n    }\n  }\n  ul {\n    list-style: auto;\n    @include mq(mobile) {\n      padding-left: 30px;\n    }\n    li {\n      margin-bottom: 20px;\n      font-family: $regular;\n      line-height: 1.6;\n      // text-align: justify;\n      @include mq(mobile) {\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n// donate form modal\n.options button {\n  margin: 15px;\n  padding: 18px 16px;\n  border: none;\n  cursor: pointer;\n\n  .wrapper-icon {\n    display: flex;\n    align-items: center;\n    width: 25px;\n    height: 25px;\n    margin: auto;\n  }\n  .credit-card {\n    margin: auto;\n  }\n  .crypto-card {\n    width: 16px;\n    margin: auto;\n    @include mq(mobile) {\n      width: 13px;\n    }\n  }\n}\n\n.options button.selected {\n  background-color: $blue;\n  color: white !important;\n}\n\n.pay-now-btn {\n  padding: 10px 20px;\n  background-color: #2ecc71;\n  border: none;\n  color: white;\n  cursor: pointer;\n}\n\n.pay-now-btn:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.amount-input {\n  margin: 10px 0;\n  color: black;\n  @include mq(mobile) {\n  }\n}\n\n.amount-input label {\n  display: block;\n  margin-bottom: 5px;\n  @include mq(mobile) {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n}\n\n.amount-input input {\n  width: 100%;\n  padding: 8px;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 30px 0;\n  border-radius: 8px;\n  text-align: center;\n  font-family: $regular;\n  max-width: 900px;\n\n  .copy-head {\n    margin-bottom: 40px;\n    color: $blue;\n    text-align: center;\n    font-family: $regular;\n    font-weight: 700;\n    font-size: 19px;\n    @include mq(mobile) {\n      margin-bottom: 30px;\n\n      padding: 0 30px;\n      font-size: 15px;\n    }\n  }\n\n  @include mq(mobile) {\n    width: 90%;\n    padding-top: 25px;\n    margin: auto;\n  }\n\n  h2 {\n    color: $blue;\n    font-size: 20px;\n    text-align: start;\n    margin-bottom: 20px;\n  }\n  p {\n    color: black;\n    text-align: left;\n    @include mq(mobile) {\n    }\n  }\n}\n\n.amount-input {\n  display: flex;\n  align-items: center;\n  margin: 10px 0;\n  text-align: left;\n  font-family: $regular;\n  border-bottom: 1px solid #d7d7d7;\n  @include mq(mobile) {\n    margin-bottom: 10px;\n  }\n}\n\n.amount-input label {\n  font-family: $regular;\n  font-weight: bold;\n}\n\n.amount-input input {\n  flex: 1;\n  margin-left: 5px;\n  padding: 8px;\n  border: 1px solid $blue;\n  border-radius: 4px;\n  max-width: 200px;\n}\ninput[type=\"text\"]:focus {\n  border: 2px solid $blue;\n}\n::placeholder {\n  font-family: $regular;\n}\n\n.total-amount {\n  font-weight: bold;\n  color: black;\n  font-family: $regular;\n  border-top: 1px solid #ccc;\n  padding-top: 25px;\n  margin-bottom: 25px;\n  @include mq(mobile) {\n  }\n}\n.options {\n  border-radius: 5px;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 10px;\n  font-family: $regular;\n  @include mq(mobile) {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n\n  p {\n    text-align: center;\n    margin-bottom: 20px;\n    font-size: 16px;\n    color: black;\n  }\n\n  .payment-div {\n    display: flex;\n    gap: 2rem;\n    justify-content: center;\n    align-items: center;\n    .or-name {\n      font-size: 1.2rem;\n      font-family: $regular;\n      text-transform: uppercase;\n    }\n    .white-color {\n      color: $blue;\n    }\n    p {\n      font-size: 15px;\n    }\n  }\n}\n.options button {\n  margin: 10px;\n  padding: 20px 21px;\n  border: none;\n  cursor: pointer;\n  font-family: $regular;\n  color: $blue;\n  border-radius: 50%;\n  border: 1px solid $blue;\n\n  @include mq(mobile) {\n    padding: 13px 14px;\n  }\n}\n\n.options button.selected {\n  color: white;\n  border-radius: 50%;\n}\n\n.pay-now-btn {\n  display: table;\n  padding: 12px 42px;\n  font-family: $regular;\n  font-size: 26px;\n  border: 2px $blue solid;\n  border-radius: 5px;\n  background-color: white;\n  color: $blue;\n  margin: auto;\n  margin-bottom: 15px;\n\n  &:hover {\n    color: white;\n    background-color: $blue;\n    border: 2px $blue solid;\n    transition: 0.3s all ease-in-out;\n  }\n  @include mq(mobile) {\n    padding: 10px 22px;\n    font-size: 21px;\n  }\n}\n\n.pay-now-btn:disabled {\n  background-color: white;\n  color: $blue;\n  cursor: not-allowed;\n}\n.input-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: baseline;\n  row-gap: 5px;\n  position: relative;\n  .error-message-0 {\n    color: red !important;\n    font-size: 9px;\n    position: absolute;\n    left: 5px;\n    bottom: -54%;\n    width: 123%;\n    @include mq(mobile) {\n      position: absolute;\n      left: 7px;\n      bottom: -42%;\n    }\n  }\n}\n.error-message-1 {\n  color: red !important;\n  position: absolute !important;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  font-size: 9px !important;\n  @include mq(mobile) {\n    width: 100%;\n  }\n}\n.close-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n  outline: none;\n  color: $blue !important;\n  @include mq(mobile) {\n    top: 5px;\n    right: 5px;\n  }\n}\n\n.main-div {\n  position: relative;\n  .banner {\n    padding-bottom: 9rem;\n    @include mq(mobile) {\n      padding-bottom: 9rem;\n    }\n    @include mq(tab) {\n      padding-bottom: 11rem;\n    }\n  }\n  .about {\n    padding-top: 15rem;\n    @include mq(mobile) {\n      padding-top: 15rem;\n    }\n  }\n  .donate-page-form {\n    max-width: 900px;\n    position: absolute;\n    top: 0;\n    position: absolute;\n    top: 58%; /* position the top  edge of the element at the middle of the parent */\n    left: 50%; /* position the left edge of the element at the middle of the parent */\n\n    transform: translate(-50%, -57%);\n    width: 80%;\n    @include mq(mobile) {\n      top: 50%; /* position the top  edge of the element at the middle of the parent */\n      left: 50%; /* position the left edge of the element at the middle of the parent */\n      width: 100%;\n      transform: translate(-50%, -50%);\n    }\n    @include mq(tab) {\n      top: 60%;\n    }\n  }\n}\n\n.server-program {\n  .container {\n    width: 90%;\n  }\n  .faq {\n    background-color: #f5f5f5;\n    padding-top: 50px;\n    padding-bottom: 50px;\n\n    .about-wrapper {\n      border-radius: 20px;\n      padding: 3rem;\n      background-color: #3b20e2;\n      display: flex;\n      align-items: flex-start;\n      @include mq(mobile) {\n        padding: 2rem;\n        flex-direction: column;\n      }\n      .about-head {\n        flex: 1;\n        font-size: 30px;\n        color: white;\n        font-family: $regular;\n        @include mq(mobile) {\n          font-size: 25px;\n        }\n      }\n      .about-copy {\n        flex: 2;\n        .copy {\n          color: white;\n          font-family: $regular;\n          font-size: 15px;\n          margin-top: 10px;\n          margin-bottom: 30px;\n          line-height: 1.5;\n          @include mq(mobile) {\n          }\n\n          &:last-child {\n            margin-bottom: unset;\n          }\n        }\n      }\n    }\n    .faq-wrapper {\n      padding: 3rem;\n      margin-top: 50px;\n      border-radius: 20px;\n      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n      display: flex;\n      justify-content: center;\n      align-items: flex-start;\n      background-color: white;\n      @include mq(mobile) {\n        flex-direction: column;\n        padding: 2rem;\n        margin-top: 30px;\n      }\n      .faq-head {\n        font-family: $regular;\n        font-size: 30px;\n        color: #3b20e2;\n        flex: 1;\n        @include mq(mobile) {\n          font-size: 25px;\n        }\n      }\n      .faq-item {\n        flex: 2;\n        .faq-copy-wrapper {\n          .qt-ans {\n            padding-right: 30px;\n            font-family: $regular;\n            margin-bottom: 30px;\n            @include mq(mobile) {\n              padding-right: 0px;\n            }\n            &:last-child {\n              @include mq(mobile) {\n                margin-bottom: 10px;\n              }\n            }\n\n            .qt {\n              color: $blue;\n              font-weight: 700;\n              font-size: 18px;\n              line-height: 1.5;\n              margin-bottom: 8px;\n              @include mq(mobile) {\n                font-size: 15px;\n                margin-top: 20px;\n              }\n            }\n            .ans {\n              font-size: 16px;\n              line-height: 1.5;\n              @include mq(mobile) {\n                font-size: 14px;\n              }\n              .link-a {\n                color: $blue;\n                font-weight: 700;\n\n                &:hover {\n                  color: #08d0ae;\n                  transition: all 0.2s ease-in-out;\n                }\n              }\n            }\n          }\n        }\n        .accordion-wrapper {\n          margin-bottom: 30px;\n          .accordion-item {\n            margin-bottom: 10px;\n            .accordion-title {\n              background-color: $blue;\n              padding: 10px;\n              cursor: pointer;\n              border: none;\n              width: 100%;\n              text-align: left;\n              display: flex;\n              justify-content: space-between;\n              font-size: 18px;\n              color: white;\n              font-family: $regular;\n              border-radius: 10px;\n              font-size: 20px;\n              @include mq(mobile) {\n                font-size: 15px;\n              }\n            }\n            .accordion-content {\n              padding: 10px;\n              background-color: #fafafa;\n              font-family: $regular;\n              font-size: 16px;\n              border-bottom-left-radius: 10px;\n              border-bottom-right-radius: 10px;\n              box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n              @include mq(mobile) {\n                font-size: 14px;\n              }\n            }\n          }\n        }\n        .faq-acc-ans {\n          .flex-class {\n            display: flex;\n            margin-bottom: 5px;\n            .flex-item {\n              flex: 1;\n            }\n            .flex-item1 {\n              flex: 2;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n//\n// Delegation Program Page Css\n\n.floating-card {\n  position: relative;\n  padding-bottom: 280px;\n  background-color: #f5f5f5;\n  .fc-wrapper {\n    position: absolute;\n    top: -70px;\n    left: 50%;\n    transform: translateX(-50%);\n    display: flex;\n    gap: 20px;\n\n    .loading-spinner {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100vh;\n      background-color: transparent;\n      position: fixed;\n      top: -140px;\n      left: 0;\n      right: 0;\n      bottom: 0;\n\n      &::after {\n        content: \"\";\n        width: 34px;\n        height: 34px;\n        border: 2px solid $blue;\n        border-radius: 50%;\n        border-top-color: transparent;\n        animation: spin 1s linear infinite;\n      }\n\n      @keyframes spin {\n        to {\n          transform: rotate(360deg);\n        }\n      }\n    }\n\n    .fc-card {\n      flex: 1 0 28%;\n      color: $blue;\n      background-color: white;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 15px;\n      padding: 40px 20px;\n      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n      border-radius: 15px;\n      .numbers {\n        font-family: $regular;\n        font-size: 32px;\n        font-weight: 700;\n      }\n      .copy {\n        font-family: $regular;\n        font-size: 30px;\n        text-align: center;\n        font-weight: 700;\n      }\n    }\n  }\n\n  @include mq(mobile) {\n    padding-bottom: 638px;\n    .fc-wrapper {\n      flex-direction: column;\n\n      .fc-card {\n        padding: 20px;\n        .numbers {\n          font-size: 20px;\n        }\n        .copy {\n          font-size: 20px;\n        }\n      }\n    }\n  }\n}\n\n.about-program {\n  background-color: #f5f5f5;\n  padding: 50px 0;\n  padding-bottom: 80px;\n  @include mq(mobile) {\n    padding-bottom: 60px;\n  }\n  @include mq(mobile) {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  .ap-wrapper {\n    position: relative;\n    background-color: $blue;\n    padding: 60px 40px;\n    border-radius: 15px;\n\n    @include mq(mobile) {\n      padding: 40px 20px;\n    }\n    .about-one {\n      position: absolute;\n      top: 0;\n      width: 100px;\n      right: 0px;\n      top: -60px;\n      right: 100px;\n      @include mq(mobile) {\n        width: 60px;\n        top: -30px;\n        right: 20px;\n      }\n    }\n    .about-two {\n      position: absolute;\n      bottom: 0;\n      width: 60px;\n      bottom: -30px;\n      @include mq(mobile) {\n        width: 40px;\n        bottom: -20px;\n      }\n    }\n\n    .abt-heading {\n      font-family: $regular;\n      font-size: 30px;\n      color: white;\n      font-weight: 700;\n    }\n    .abt-copy {\n      color: white;\n      font-family: $regular;\n      font-size: 15px;\n      line-height: 1.5;\n      margin-top: 16px;\n    }\n  }\n}\n\n.delegation-criteria {\n  background-color: white;\n  padding: 60px 0;\n  .dc-heading {\n    font-family: $regular;\n    font-size: 30px;\n    color: $blue;\n    text-transform: capitalize;\n    margin-bottom: 1rem;\n    font-weight: 700;\n  }\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n  .dc-wrapper {\n    display: flex;\n    gap: 40px;\n\n    .wrapper-item {\n      position: relative;\n      padding-bottom: 400px;\n      flex: 1;\n      @include mq(mobile) {\n        padding-bottom: 370px;\n      }\n\n      .dc-copy {\n        font-family: $regular;\n        font-size: 15px;\n        line-height: 1.5;\n        margin-bottom: 40px;\n        @include mq(mobile) {\n          margin-bottom: 30px;\n        }\n      }\n      .img-wrap {\n        height: 400px;\n\n        display: flex;\n        align-items: center;\n        position: absolute;\n        left: 50%;\n        transform: translateX(-50%);\n        justify-content: center;\n        @include mq(mobile) {\n          height: 350px;\n        }\n        .img-1 {\n          align-self: auto;\n          width: 90px;\n        }\n        .img-2 {\n          align-self: flex-end;\n          width: 90px;\n        }\n        .img-3 {\n          align-self: flex-start;\n          width: 90px;\n        }\n        // .images {\n        // }\n      }\n    }\n\n    .wrapper-accordion {\n      flex: 1;\n      margin-bottom: 10px;\n      .accordion-item {\n        margin-bottom: 20px;\n      }\n      .accordion-title {\n        background-color: $blue;\n        padding: 10px;\n        cursor: pointer;\n        border: none;\n        width: 100%;\n        text-align: left;\n        display: flex;\n        justify-content: space-between;\n        font-size: 18px;\n        color: white;\n        font-family: $regular;\n        border-radius: 10px;\n        font-size: 20px;\n        font-weight: 700;\n\n        @include mq(mobile) {\n          font-size: 15px;\n        }\n      }\n      .accordion-content {\n        padding: 10px;\n        background-color: #fafafa;\n        font-family: $regular;\n        font-size: 15px;\n        border-bottom-left-radius: 10px;\n        border-bottom-right-radius: 10px;\n        box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n        transition: 0.3s ease-out;\n        line-height: 1.5;\n        @include mq(mobile) {\n          font-size: 14px;\n        }\n      }\n    }\n\n    @include mq(mobile) {\n      flex-direction: column;\n    }\n  }\n}\n\n//\n.delegated-validators {\n  background-color: #f5f5f5;\n  padding: 60px 0;\n  @include mq(mobile) {\n    padding: 40px 0;\n  }\n  .dv-wrapper {\n    .dv-header {\n      display: flex;\n      @include mq(mobile) {\n        flex-direction: column;\n      }\n      .dv-heading {\n        flex: 1;\n        font-family: $regular;\n        font-size: 34px;\n        color: $blue;\n        font-weight: 700;\n        @include mq(mobile) {\n          margin-bottom: 20px;\n        }\n      }\n      p {\n        flex: 1;\n        font-family: $regular;\n      }\n    }\n    .dv-card-section {\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      gap: 20px;\n      margin-top: 80px;\n      @include mq(mobile) {\n        padding: 0 60px;\n        gap: 10px;\n        grid-template-columns: repeat(1, 1fr);\n        gap: 20px;\n      }\n      @include mq(tab) {\n        padding: 0 40px;\n        column-gap: 30px;\n        grid-template-columns: repeat(2, 1fr);\n      }\n\n      .dv-card {\n        padding: 40px 30px;\n        border-radius: 10px;\n        box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\n        flex: 1 0 28%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        gap: 20px;\n        padding-top: 60px;\n\n        cursor: pointer;\n\n        @include mq(mobile) {\n          padding: 20px;\n          padding-top: 40px;\n          gap: 20px;\n        }\n        @include mq(tab) {\n          padding: 20px;\n          margin-top: 30px;\n        }\n\n        .num-plate {\n          border: 1px #cfcfcf solid;\n          border-radius: 50%;\n          padding: 12px;\n          font-family: $regular;\n          align-self: flex-start;\n        }\n\n        .img-copy-wrapper {\n          margin-top: 60px;\n\n          display: flex;\n          flex-direction: column;\n          gap: 100px;\n        }\n        .card-copy {\n          font-family: $regular;\n          color: #8f8f8f;\n          font-size: 24px;\n          font-weight: 700;\n          text-align: start;\n          align-self: flex-start;\n          margin-top: 60px;\n          @include mq(mobile) {\n            margin-top: 30px;\n            font-size: 20px;\n          }\n        }\n        .card-img {\n          margin-top: 60px;\n          transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;\n          opacity: 1;\n          @include mq(mobile) {\n            width: 130px;\n            margin-top: 30px;\n          }\n        }\n        .stakebin {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/stakebin-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .delight {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/Delight-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .terrarium {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/Terrarium-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .terraport {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/terraport-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .nodeops {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/nodeops-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n\n        .burnit-all {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/Burn\\ it\\ all\\ grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .tcb {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images//greyLogo/TCB-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .vegas {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/Vegas-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .lunc {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/Lunc-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .stake-system {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/stake-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n        .hexxagon {\n          width: 110px;\n          height: 110px;\n          background-image: url(\"../images/greyLogo/hexxagon-grey.png\");\n          background-repeat: no-repeat;\n          background-position: center;\n        }\n\n        &:hover {\n          transition: 0.3s all;\n          .num-plate {\n            color: white;\n          }\n          .card-copy {\n            transition: 0.3s all;\n            transition-delay: 0.001s;\n            color: $blue;\n          }\n\n          .stakebin {\n            background-image: url(\"../images/greyLogo/stakebin-Blue.png\");\n          }\n\n          .delight {\n            background-image: url(\"../images/greyLogo/Delight-blue.png\");\n          }\n\n          .terrarium {\n            background-image: url(\"../images/greyLogo/Terrarium-blue.png\");\n          }\n\n          .terraport {\n            background-image: url(\"../images/greyLogo/terraport-blue.png\");\n          }\n\n          .nodeops {\n            background-image: url(\"../images/greyLogo/nodeops-blue.png\");\n          }\n\n          .burnit-all {\n            background-image: url(\"../images/greyLogo/Burn\\ it\\ all.png\");\n          }\n\n          .tcb {\n            background-image: url(\"../images/greyLogo/TCB-blue.png\");\n          }\n\n          .vegas {\n            background-image: url(\"../images/greyLogo/Vegas-blue.png\");\n          }\n\n          .lunc {\n            background-image: url(\"../images/greyLogo/Lunc.png\");\n          }\n\n          .stake-system {\n            background-image: url(\"../images/greyLogo/stake-blue.png\");\n          }\n\n          .hexxagon {\n            background-image: url(\"../images/greyLogo/hexxagon-blue.png\");\n          }\n        }\n      }\n\n      @include mq(mobile) {\n        flex-direction: column;\n        align-items: unset;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
